(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = download;

function download(url) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'download';
  fetch(url).then(function (t) {
    return t.blob().then(function (b) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(b);
      a.setAttribute('download', filename);
      a.click();
    });
  });
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var fullNameToLangCode = function fullNameToLangCode() {
  var langOpener = document.querySelector('#dropdownMenuButton-choose-lang .name');
  var langParent = document.getElementById('choose-lang');

  if (langOpener) {
    var replaceWithCode = function replaceWithCode() {
      var menuItems = document.querySelectorAll('#choose-lang a');
      var code = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = menuItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.firstChild.data == langOpener.innerHTML) {
            code = item.firstElementChild.innerHTML;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      langOpener.innerHTML = code;
    };

    $(langParent).on('select_changed', function () {
      replaceWithCode();
    });
    replaceWithCode();
  }
};

var _default = fullNameToLangCode;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var headerHoverHelper = function headerHoverHelper() {
  var header = document.querySelector('#header');
  var items = document.querySelectorAll('#header .top-nav-items');
  var targetClassName = 'item-with-full-width-drop';
  var activeClass = 'item-with-full-width-drop-hovered';

  _toConsumableArray(items).forEach(function (el) {
    if (el.querySelector('.full-width-drop')) {
      el.classList.add(targetClassName);
    }
  });

  var fwItems = document.querySelectorAll(".".concat(targetClassName));

  var setActiveState = function setActiveState() {
    if (!header.classList.contains(activeClass)) {
      header.classList.add(activeClass);
    }
  };

  var removeActiveState = function removeActiveState() {
    if (header.classList.contains(activeClass)) {
      header.classList.remove(activeClass);
    }
  };

  var onMouseover = function onMouseover(e) {
    var target = e.target,
        currentTarget = e.currentTarget;
    var targetIsItem = target === currentTarget;
    var targetInsideItem = target.closest(".".concat(targetClassName));

    if (targetIsItem || targetInsideItem) {
      setActiveState();
    }
  };

  var onMouseout = function onMouseout(e) {
    var relatedTarget = e.relatedTarget,
        currentTarget = e.currentTarget;
    var targetIsNotItem = relatedTarget ? relatedTarget !== currentTarget : null;
    var targetNotInsideItem = relatedTarget ? !relatedTarget.closest(".".concat(targetClassName)) : null;

    if (!relatedTarget || targetIsNotItem && targetNotInsideItem) {
      removeActiveState();
    }
  };

  return {
    init: function init() {
      if (header) {
        _toConsumableArray(fwItems).forEach(function (item) {
          item.addEventListener('mouseover', onMouseover);
          item.addEventListener('mouseout', onMouseout);
        });
      }
    },
    destroy: function destroy() {
      if (header) {
        _toConsumableArray(fwItems).forEach(function (item) {
          item.removeEventListener('mouseover', onMouseover);
          item.removeEventListener('mouseout', onMouseout);
        });

        header.classList.remove(activeClass);
      }
    }
  };
};

var _default = headerHoverHelper;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var headerAccordion = function headerAccordion(opts) {
  var accParent = opts.accParent,
      accItems = opts.accItems,
      openerSelector = opts.openerSelector,
      dropSelector = opts.dropSelector;

  var btnClickFn = function btnClickFn(e) {
    e.preventDefault();
    var opener = e.currentTarget;
    var drop = opener.accrodionDrop;

    if (drop) {
      $(drop).collapse('toggle');
    }
  };

  var onShowBsCollapse = function onShowBsCollapse(e) {
    e.stopPropagation();
    var drop = e.currentTarget;
    var opener = drop.accrodionOpener;

    if (opener) {
      opener.setAttribute('aria-expanded', true);
    }
  };

  var onHideBsCollapse = function onHideBsCollapse(e) {
    e.stopPropagation();
    var drop = e.currentTarget;
    var opener = drop.accrodionOpener;

    if (opener) {
      opener.setAttribute('aria-expanded', false);
    }
  };

  return {
    init: function init() {
      if (accParent && accItems) {
        _toConsumableArray(accItems).forEach(function (el) {
          if (!el.classList.contains('without-mobile-collapse')) {
            var opener = el.querySelector(openerSelector);
            var drop = el.querySelector(dropSelector);

            if (opener && drop) {
              drop.style.display = '';
              drop.classList.add('collapse');
              drop.accrodionOpener = opener;
              opener.accrodionDrop = drop;
              opener.originalHref = opener.getAttribute('href'); // javascript:void(0) removes delay from collapse
              // delay chappens as gtm elements on click send xhr and block runtime

              opener.setAttribute('href', 'javascript:void(0)');
              opener.setAttribute('aria-expanded', 'false');
              $(drop).collapse({
                parent: accParent,
                toggle: false
              });
              $(drop).on('hide.bs.collapse', onHideBsCollapse);
              $(drop).on('show.bs.collapse', onShowBsCollapse);
              opener.addEventListener('click', btnClickFn);
              el.accordionInited = true;
            }
          }
        });
      }
    },
    destroy: function destroy() {
      if (accParent && accItems) {
        _toConsumableArray(accItems).forEach(function (el) {
          if (el.accordionInited) {
            el.accordionInited = false;
            var opener = el.querySelector(openerSelector);
            var drop = el.querySelector(dropSelector);

            if (opener && drop) {
              opener.removeEventListener('click', btnClickFn);

              if (opener.originalHref) {
                opener.setAttribute('href', opener.originalHref);
              }

              $(drop).off('hidden.bs.collapse', onHideBsCollapse);
              $(drop).off('shown.bs.collapse', onShowBsCollapse);
              drop.classList.remove('collapse');
              drop.accrodionOpener = null;
              $(drop).collapse('dispose');
              opener.accrodionDrop = null;
              opener.removeAttribute('aria-expanded');
            }
          }
        });
      }
    }
  };
};

var _default = headerAccordion;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "makeResponsiveHeaderTemplateNew", {
  enumerable: true,
  get: function get() {
    return _makeResponsiveHeaderTemplate["default"];
  }
});
Object.defineProperty(exports, "setHeaderHeight", {
  enumerable: true,
  get: function get() {
    return _setHeaderHeight["default"];
  }
});
Object.defineProperty(exports, "fullNameToLangCode", {
  enumerable: true,
  get: function get() {
    return _fullnameToLangCode["default"];
  }
});
Object.defineProperty(exports, "makeHoverTBDropdown", {
  enumerable: true,
  get: function get() {
    return _makeHoverTbDropdown["default"];
  }
});
Object.defineProperty(exports, "setNavHeight", {
  enumerable: true,
  get: function get() {
    return _setNavHeight["default"];
  }
});
Object.defineProperty(exports, "isTouchDevice", {
  enumerable: true,
  get: function get() {
    return _isTouchDevice["default"];
  }
});
Object.defineProperty(exports, "handleHeaderHovering", {
  enumerable: true,
  get: function get() {
    return _handleHeaderHovering["default"];
  }
});
Object.defineProperty(exports, "navBarItemsClick", {
  enumerable: true,
  get: function get() {
    return _navBarItemsClick["default"];
  }
});
Object.defineProperty(exports, "headerAccordion", {
  enumerable: true,
  get: function get() {
    return _headerAccordion["default"];
  }
});
Object.defineProperty(exports, "setScreenWidth", {
  enumerable: true,
  get: function get() {
    return _setScreenWidth["default"];
  }
});

var _makeResponsiveHeaderTemplate = _interopRequireDefault(require("./make-responsive-header-template-2"));

var _setHeaderHeight = _interopRequireDefault(require("./set-header-height"));

var _fullnameToLangCode = _interopRequireDefault(require("./fullname-to-lang-code"));

var _makeHoverTbDropdown = _interopRequireDefault(require("./make-hover-tb-dropdown"));

var _setNavHeight = _interopRequireDefault(require("./set-nav-height"));

var _isTouchDevice = _interopRequireDefault(require("./is-touch-device"));

var _handleHeaderHovering = _interopRequireDefault(require("./handle-header-hovering"));

var _navBarItemsClick = _interopRequireDefault(require("./nav-bar-items-click"));

var _headerAccordion = _interopRequireDefault(require("./header-accordion"));

var _setScreenWidth = _interopRequireDefault(require("./set-screen-width"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

},{"./fullname-to-lang-code":2,"./handle-header-hovering":3,"./header-accordion":4,"./is-touch-device":6,"./make-hover-tb-dropdown":7,"./make-responsive-header-template-2":8,"./nav-bar-items-click":9,"./set-header-height":10,"./set-nav-height":11,"./set-screen-width":12}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isTouchDevice;

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeHoverTBDropdown = function makeHoverTBDropdown(drop) {
  var inited = false;

  var onMouseout = function onMouseout(e) {
    var drop = e.currentTarget,
        relatedTarget = e.relatedTarget,
        target = e.target;
    var expanded = drop.classList.contains('show');
    var btn = drop.querySelector('.dropdown-btn');

    if (expanded && btn) {
      if (!relatedTarget || relatedTarget !== drop && !relatedTarget.closest("#".concat(drop.id))) {
        btn.click();
        drop.removeEventListener('mouseout', onMouseout);
      }
    }
  };

  var onMouseover = function onMouseover(e) {
    var drop = e.currentTarget;
    var expanded = drop.classList.contains('show');
    var btn = drop.querySelector('.dropdown-btn');

    if (!expanded && btn) {
      btn.click();
      drop.removeEventListener('mouseout', onMouseout);
      drop.addEventListener('mouseout', onMouseout);
    }
  };

  return {
    init: function init() {
      if (drop && typeof $.fn.dropdown === 'function') {
        inited = true;
        drop.addEventListener('mouseover', onMouseover);
      }
    },
    destroy: function destroy() {
      if (drop && inited) {
        inited = false;
        drop.removeEventListener('mouseover', onMouseover);
        drop.removeEventListener('mouseout', onMouseout);
      }
    }
  };
};

var _default = makeHoverTBDropdown;
exports["default"] = _default;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helpers = require("../../main/helpers");

var appendLoginIcon = function appendLoginIcon() {
  var icon = document.getElementById('login-icon');

  if (icon) {
    var loginBtn = document.querySelector('#choose-login .dropdown-btn');

    if (loginBtn) {
      loginBtn.insertAdjacentElement('afterbegin', icon);
    }
  }
};

var makeResponsiveHeaderTemplate = function makeResponsiveHeaderTemplate() {
  // add icon to login button
  appendLoginIcon(); // items to insert

  var login = document.getElementById('choose-login');
  var lang = document.getElementById('choose-lang');
  var underAttackLink = document.getElementById('under-attack-link');
  var phoneNumberLink = document.getElementById('phone-number-link');
  var btnsBar = document.querySelector('#header .header-btns-div'); // holders

  var rightHolder = document.querySelector('#header .holder-right-bar');
  var subNav = document.querySelector('#header .sub-nav');
  var wrap = document.querySelector('#header .nav-holder .wrap');
  var wrapDesktop = document.querySelector('#header .nav-holder .wrap .sub-nav-container');

  var insertEls = function insertEls(list, holder, insertMethod) {
    list.forEach(function (el) {
      if (el && holder) {
        holder.insertAdjacentElement(insertMethod, el);
      }
    });
  };

  var moveItemsToSubNav = function moveItemsToSubNav() {
    insertEls([underAttackLink, phoneNumberLink, login], subNav, 'afterbegin');
    insertEls([lang], subNav, 'beforeend');
  };

  _helpers.ResponsiveHelper.addRange({
    '..767': {
      on: function on() {
        insertEls([subNav, btnsBar], wrap, 'beforeend');
        insertEls([underAttackLink, phoneNumberLink], subNav, 'beforeend');
        insertEls([login, lang], rightHolder, 'beforeend');
      }
    },
    '768..1199': {
      on: function on() {
        insertEls([subNav, btnsBar], wrap, 'beforeend');
        insertEls([login, lang], subNav, 'beforeend');
        insertEls([underAttackLink, phoneNumberLink], rightHolder, 'beforeend');
      }
    },
    '1200..': {
      on: function on() {
        insertEls([subNav], wrapDesktop, 'beforeend');
        insertEls([underAttackLink, phoneNumberLink, login, lang], subNav, 'beforeend');
      }
    }
  });
};

var _default = makeResponsiveHeaderTemplate;
exports["default"] = _default;

},{"../../main/helpers":20}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var navBarItemsClick = function navBarItemsClick() {
  var outsideClickTimer = null;
  var pageHtml = document.documentElement;
  var header = document.querySelector('#header');
  var navMain = document.getElementById('nav-main');
  var menuTopItems = navMain && navMain.querySelectorAll('.top-nav-items');
  var dropsSelector = '#nav-main .drop, #nav-main .full-width-drop';
  var drops = document.querySelectorAll(dropsSelector);
  var dropOpenClass = 'open';
  var activeClassFwDrop = 'full-width-drop-click-opened';

  var removeOutsideClickListener = function removeOutsideClickListener() {
    clearTimeout(outsideClickTimer);
    pageHtml.removeEventListener('click', onDocClick);
  };

  var onDocClick = function onDocClick(e) {
    var t = e.target;

    if (drops) {
      var spreadedDrops = _toConsumableArray(drops);

      if (spreadedDrops.indexOf(t) < 0 && !t.closest(dropsSelector)) {
        removeOutsideClickListener();
        spreadedDrops.forEach(function (el) {
          var li = el.closest('li');

          if (li) {
            li.classList.remove(dropOpenClass);
          }
        });
        header.classList.remove(activeClassFwDrop);
      }
    }
  };

  var onLIClick = function onLIClick(e) {
    var li = e.currentTarget;
    var hasFwDrop = li.querySelector('.full-width-drop');
    li.classList.toggle(dropOpenClass);

    if (hasFwDrop) {
      if (li.classList.contains(dropOpenClass)) {
        header.classList.add(activeClassFwDrop);
      } else {
        header.classList.remove(activeClassFwDrop);
      }
    } else {
      header.classList.remove(activeClassFwDrop);
    } // handle outside drop click


    removeOutsideClickListener();
    outsideClickTimer = setTimeout(function () {
      pageHtml.addEventListener('click', onDocClick);
    }, 100);
  };

  var runForEveryLI = function runForEveryLI(cb) {
    if (menuTopItems) {
      _toConsumableArray(menuTopItems).forEach(function (li) {
        var drop = li.querySelector('.drop, .full-width-drop');

        if (drop) {
          if (cb && typeof cb === 'function') {
            cb(li);
          }
        }
      });
    }
  };

  return {
    init: function init() {
      runForEveryLI(function (li) {
        li.addEventListener('click', onLIClick);
      });
    },
    destroy: function destroy() {
      removeOutsideClickListener();
      header.classList.remove(activeClassFwDrop);
      runForEveryLI(function (li) {
        li.removeEventListener('click', onLIClick);
        li.classList.remove(dropOpenClass);
      });
    }
  };
};

var _default = navBarItemsClick;
exports["default"] = _default;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helpers = require("../../main/helpers");

var setHeaderHeight = function setHeaderHeight() {
  var header = document.getElementById('header');
  var wrap = document.querySelector('.header-placeholder');
  var prevHeight = '';
  if (!header || !wrap) return;

  var setHeight = function setHeight() {
    var headerStyles = window.getComputedStyle(header);
    var h = headerStyles.getPropertyValue('height');

    if (prevHeight !== h) {
      prevHeight = h;
      wrap.style.height = h;
    }
  };

  var resizeHandler = function resizeHandler() {
    setHeight();
  };

  setHeight();
  window.addEventListener('resize', (0, _helpers.throttle)(resizeHandler, 400));
  window.addEventListener('orientationchange', resizeHandler);
};

var _default = setHeaderHeight;
exports["default"] = _default;

},{"../../main/helpers":20}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var setNavHeight = function setNavHeight() {
  var root = document.documentElement;
  var propName = '--nav-height';
  var startVal = getComputedStyle(root).getPropertyValue(propName);
  var header = document.querySelector('#header');
  var banner = null;
  var closeBtn = null;
  var wasInited = false;

  var findBannerEls = function findBannerEls() {
    banner = document.querySelector('.cookie-consent-banner');
    closeBtn = document.querySelector('.cookie-consent-banner .close-btn-consent');
  };

  var makeInit = function makeInit() {
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    if (closeBtn) {
      closeBtn.addEventListener('click', onCloseBtnClick);
    }

    setHeight();
  };

  var makeDestroy = function makeDestroy() {
    // find banner, it might be deleted
    findBannerEls();
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onResize);

    if (closeBtn) {
      closeBtn.removeEventListener('click', onCloseBtnClick);
    } // avoid adding unneeded eventListeners if banner was deleted


    if (!banner) {
      document.removeEventListener('cookieconsentbannerinserted', onCookieconsentbannerinserted);
    }

    root.style.setProperty(propName, '');
  };

  var setHeight = function setHeight() {
    var bannerHeight = banner ? banner.offsetHeight : 0;
    var headerHeight = header ? header.offsetHeight : 0;
    var val = "calc(var(--screen-height) - ".concat(headerHeight + bannerHeight, "px)");

    if (val !== startVal) {
      root.style.setProperty(propName, val);
    }
  };

  var onResize = function onResize(e) {
    setHeight();
  };

  var onCloseBtnClick = function onCloseBtnClick(e) {
    makeDestroy();
  };

  function onCookieconsentbannerinserted() {
    findBannerEls(); // make init if destroy fn wasn't called

    if (!wasInited) return;
    makeInit();
  }

  var setWinHeight = function setWinHeight() {
    document.documentElement.style.setProperty('--screen-height', "".concat(window.innerHeight, "px"));
  };

  setWinHeight();
  window.addEventListener('resize', setWinHeight);
  window.addEventListener('orientaionchange', setWinHeight);
  return {
    init: function init() {
      wasInited = true;
      findBannerEls();

      if (banner) {
        // init if banner exist
        makeInit();
      } else {
        // init on insert callback if banner doesn't exist
        document.addEventListener('cookieconsentbannerinserted', onCookieconsentbannerinserted);
      }
    },
    destroy: function destroy() {
      wasInited = false;
      makeDestroy();
    }
  };
};

var _default = setNavHeight;
exports["default"] = _default;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var setScreenWidth = function setScreenWidth() {
  var docEl = document.documentElement;

  var setWidth = function setWidth() {
    docEl.style.setProperty('--screen-width', "".concat(docEl.clientWidth, "px"));
  };

  var removeWidth = function removeWidth() {
    docEl.style.setProperty('--screen-width', '');
  };

  return {
    init: function init() {
      setWidth();
      window.addEventListener('resize', setWidth);
      window.addEventListener('orientaionchange', setWidth);
    },
    destroy: function destroy() {
      window.removeEventListener('resize', setWidth);
      window.removeEventListener('orientaionchange', setWidth);
      removeWidth();
    }
  };
};

var _default = setScreenWidth;
exports["default"] = _default;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HoverClass =
/*#__PURE__*/
function () {
  function HoverClass(holder, opts) {
    _classCallCheck(this, HoverClass);

    if (holder) {
      this.holder = holder;
      this.options = Object.assign({
        itemsSelector: 'li',
        dropSelector: '.drop',
        activeClass: 'opened'
      }, opts);
      this.init();
    }
  }

  _createClass(HoverClass, [{
    key: "init",
    value: function init() {
      this.findElements();
      this.attachEvents();
    }
  }, {
    key: "findElements",
    value: function findElements() {
      this.items = this.holder.querySelectorAll(this.options.itemsSelector);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.mouseoverFn = function (e) {
        var target = e.target;
        if (!target) return;

        var openedLi = _toConsumableArray(_this.items).filter(function (el) {
          return el.classList.contains(_this.options.activeClass);
        });

        if (openedLi.length) {
          var targetIsOpened = target === openedLi[0];
          var targetIsInOpened = target.closest(_this.options.itemsSelector + '.' + _this.options.activeClass);
          var targetIsItem = target.classList.contains(_this.options.itemsSelector);
          var targetIsInItem = target.closest(_this.options.itemsSelector);

          if (!targetIsOpened && !targetIsInOpened && (targetIsItem || targetIsInItem)) {
            openedLi.forEach(function (el) {
              var drop = el.querySelector(_this.options.dropSelector);
              el.classList.remove(_this.options.activeClass);

              if (drop) {
                drop.style.display = 'none';
              }
            });
          }
        }
      };

      this.holder.addEventListener('mouseover', this.mouseoverFn);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.holder.removeEventListener('mouseover', this.mouseoverFn);
    }
  }]);

  return HoverClass;
}();

exports["default"] = HoverClass;

},{}],14:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 * Popups plugin
 */
(function ($) {
  function ContentPopupDrop(opt) {
    this.options = $.extend({
      holder: null,
      popup: '.popup',
      btnOpen: '.open',
      btnClose: '.close',
      openClass: 'popup-active',
      clickEvent: 'click',
      mode: 'click',
      hideOnClickLink: true,
      hideOnClickOutside: true,
      delay: 50
    }, opt);

    if (this.options.holder) {
      this.holder = $(this.options.holder);
      this.init();
    }
  }

  ContentPopupDrop.prototype = {
    init: function init() {
      this.findElements();
      this.attachEvents();
      this.makeCallback('onInit', this);
    },
    findElements: function findElements() {
      this.popup = this.holder.find(this.options.popup);
      this.btnOpen = this.holder.find(this.options.btnOpen);
      this.btnClose = this.holder.find(this.options.btnClose);
    },
    attachEvents: function attachEvents() {
      // handle popup openers
      var self = this;
      this.clickMode = isTouchDevice || self.options.mode === self.options.clickEvent;

      if (this.clickMode) {
        // handle click mode
        this.btnOpen.bind(self.options.clickEvent + '.popup', function (e) {
          if (self.holder.hasClass(self.options.openClass)) {
            if (self.options.hideOnClickLink) {
              self.hidePopup();
            }
          } else {
            self.showPopup();
          }

          e.preventDefault();
        }); // prepare outside click handler

        this.outsideClickHandler = this.bind(this.outsideClickHandler, this);
      } else {
        // handle hover mode
        var timer,
            delayedFunc = function delayedFunc(func) {
          clearTimeout(timer);
          timer = setTimeout(function () {
            func.call(self);
          }, self.options.delay);
        };

        this.btnOpen.on('mouseover.popup', function () {
          delayedFunc(self.showPopup);
        }).on('mouseout.popup', function () {
          delayedFunc(self.hidePopup);
        });
        this.popup.on('mouseover.popup', function () {
          delayedFunc(self.showPopup);
        }).on('mouseout.popup', function () {
          delayedFunc(self.hidePopup);
        });
      } // handle close buttons


      this.btnClose.on(self.options.clickEvent + '.popup', function (e) {
        self.hidePopup();
        e.preventDefault();
      });
    },
    outsideClickHandler: function outsideClickHandler(e) {
      // hide popup if clicked outside
      var targetNode = $((e.changedTouches ? e.changedTouches[0] : e).target);

      if (!targetNode.closest(this.popup).length && !targetNode.closest(this.btnOpen).length) {
        this.hidePopup();
      }
    },
    showPopup: function showPopup() {
      var self = this; // reveal popup

      this.holder.addClass(this.options.openClass);
      self.makeCallback('onShow', true, self);
      this.popup.css({
        display: 'block'
      }); // outside click handler

      if (this.clickMode && this.options.hideOnClickOutside && !this.outsideHandlerActive) {
        this.outsideHandlerActive = true;
        $(document).on('click touchstart', this.outsideClickHandler);
      }
    },
    hidePopup: function hidePopup() {
      var self = this; // hide popup

      this.holder.removeClass(this.options.openClass);
      self.makeCallback('onHide', true, self);
      this.popup.css({
        display: 'none'
      }); // outside click handler

      if (this.clickMode && this.options.hideOnClickOutside && this.outsideHandlerActive) {
        this.outsideHandlerActive = false;
        $(document).off('click touchstart', this.outsideClickHandler);
      }
    },
    bind: function bind(f, scope, forceArgs) {
      return function () {
        return f.apply(scope, forceArgs ? [forceArgs] : arguments);
      };
    },
    destroy: function destroy() {
      var self = this;
      self.makeCallback('onHide', true, self);
      this.popup.removeAttr('style');
      this.holder.removeClass(this.options.openClass);
      this.btnOpen.add(this.btnClose).add(this.popup).off('.popup');
      $(document).off('click touchstart', this.outsideClickHandler);
      this.makeCallback('onDestroy', this);
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    }
  }; // detect touch devices

  var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch; // jQuery plugin interface

  $.fn.contentPopupDrop = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    return this.each(function () {
      var $holder = jQuery(this);
      var instance = $holder.data('ContentPopupDrop');

      if (_typeof(opt) === 'object' || typeof opt === 'undefined') {
        $holder.data('ContentPopupDrop', new ContentPopupDrop($.extend({
          holder: this
        }, opt)));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
})(jQuery);

},{}],15:[function(require,module,exports){
"use strict";

/*
 * jQuery SameHeight plugin
 */
(function ($) {
  $.fn.sameHeight = function (opt) {
    var options = $.extend({
      skipClass: 'same-height-ignore',
      leftEdgeClass: 'same-height-left',
      rightEdgeClass: 'same-height-right',
      elements: '>*',
      flexible: false,
      multiLine: false,
      useMinHeight: false,
      biggestHeight: false
    }, opt);
    return this.each(function () {
      var holder = $(this),
          postResizeTimer,
          ignoreResize;
      var elements = holder.find(options.elements).not('.' + options.skipClass);
      if (!elements.length) return; // resize handler

      function doResize() {
        elements.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', '');

        if (options.multiLine) {
          // resize elements row by row
          resizeElementsByRows(elements, options);
        } else {
          // resize elements by holder
          resizeElements(elements, holder, options);
        }
      }

      doResize(); // handle flexible layout / font resize

      var delayedResizeHandler = function delayedResizeHandler() {
        if (!ignoreResize) {
          ignoreResize = true;
          doResize();
          clearTimeout(postResizeTimer);
          postResizeTimer = setTimeout(function () {
            doResize();
            setTimeout(function () {
              ignoreResize = false;
            }, 10);
          }, 100);
        }
      }; // handle flexible/responsive layout


      if (options.flexible) {
        $(window).bind('resize orientationchange fontresize', delayedResizeHandler);
      } // handle complete page load including images and fonts


      $(window).bind('load', delayedResizeHandler);
    });
  }; // detect css min-height support


  var supportMinHeight = typeof document.documentElement.style.maxHeight !== 'undefined'; // get elements by rows

  function resizeElementsByRows(boxes, options) {
    var currentRow = $(),
        maxHeight,
        maxCalcHeight = 0,
        firstOffset = boxes.eq(0).offset().top;
    boxes.each(function (ind) {
      var curItem = $(this);
      /* 
        Determine if a new row starts by distance of box from top offset. 
        Run math functions to "smooth" slight discrepancies 
        '< 3' is a 3 pixel "wiggle room" 
      */

      if (Math.trunc(Math.abs(curItem.offset().top - firstOffset)) < 3) {
        currentRow = currentRow.add(this);
      } else {
        maxHeight = getMaxHeight(currentRow);
        maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
        currentRow = curItem;
        firstOffset = curItem.offset().top;
      }
    });

    if (currentRow.length) {
      maxHeight = getMaxHeight(currentRow);
      maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
    }

    if (options.biggestHeight) {
      boxes.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', maxCalcHeight);
    }
  } // calculate max element height


  function getMaxHeight(boxes) {
    var maxHeight = 0;
    boxes.each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });
    return maxHeight;
  } // resize helper function


  function resizeElements(boxes, parent, options) {
    var calcHeight;
    var parentHeight = typeof parent === 'number' ? parent : parent.height();
    boxes.removeClass(options.leftEdgeClass).removeClass(options.rightEdgeClass).each(function (i) {
      var element = $(this);
      var depthDiffHeight = 0;
      var isBorderBox = element.css('boxSizing') === 'border-box' || element.css('-moz-box-sizing') === 'border-box' || element.css('-webkit-box-sizing') === 'border-box';

      if (typeof parent !== 'number') {
        element.parents().each(function () {
          var tmpParent = $(this);

          if (parent.is(this)) {
            return false;
          } else {
            depthDiffHeight += tmpParent.outerHeight() - tmpParent.height();
          }
        });
      }

      calcHeight = parentHeight - depthDiffHeight;
      calcHeight -= isBorderBox ? 0 : element.outerHeight() - element.height();

      if (calcHeight > 0) {
        element.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', calcHeight);
      }
    });
    boxes.filter(':first').addClass(options.leftEdgeClass);
    boxes.filter(':last').addClass(options.rightEdgeClass);
    return calcHeight;
  }
})(jQuery);

},{}],16:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 * jQuery Tabs plugin
 */
(function ($, $win) {
  'use strict';

  function Tabset($holder, options) {
    this.$holder = $holder;
    this.options = options;
    this.init();
  }

  Tabset.prototype = {
    init: function init() {
      this.$tabLinks = this.$holder.find(this.options.tabLinks);
      this.setStartActiveIndex();
      this.setActiveTab();

      if (this.options.autoHeight) {
        this.$tabHolder = $(this.$tabLinks.eq(0).attr(this.options.attrib)).parent();
      }

      this.makeCallback('onInit', this);
    },
    setStartActiveIndex: function setStartActiveIndex() {
      var $classTargets = this.getClassTarget(this.$tabLinks);
      var $activeLink = $classTargets.filter('.' + this.options.activeClass);
      var $hashLink = this.$tabLinks.filter('[' + this.options.attrib + '="' + location.hash + '"]');
      var activeIndex;

      if (this.options.checkHash && $hashLink.length) {
        $activeLink = $hashLink;
      }

      activeIndex = $classTargets.index($activeLink);
      this.activeTabIndex = this.prevTabIndex = activeIndex === -1 ? this.options.defaultTab ? 0 : null : activeIndex;
    },
    setActiveTab: function setActiveTab() {
      var self = this,
          tabUnderlineClass = this.options.tabUnderlineClass ? $(".".concat(this.options.tabUnderlineClass)) : false;
      this.$tabLinks.each(function (i, link) {
        var $link = $(link);
        var $classTarget = self.getClassTarget($link);
        var $tab = $($link.attr(self.options.attrib));

        if (i !== self.activeTabIndex) {
          $classTarget.removeClass(self.options.activeClass);
          $tab.addClass(self.options.tabHiddenClass).removeClass(self.options.activeClass);
        } else {
          $classTarget.addClass(self.options.activeClass);
          $tab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);
          if (tabUnderlineClass) tabUnderlineClass.css({
            left: this.offsetLeft,
            width: this.offsetWidth
          });
        }

        self.attachTabLink($link, i);
      });
    },
    attachTabLink: function attachTabLink($link, i) {
      var self = this,
          tabUnderlineClass = this.options.tabUnderlineClass;
      $link.on(this.options.event + '.tabset', function (e) {
        e.preventDefault();

        if (self.activeTabIndex === self.prevTabIndex && self.activeTabIndex !== i) {
          self.activeTabIndex = i;
          self.switchTabs();
        }

        if (self.options.checkHash) {
          location.hash = jQuery(this).attr('href').split('#')[1];
        } // Target this specific underline slide element


        var targetedTabUnderlineSlide = this.parentElement.parentElement.querySelectorAll(".".concat(tabUnderlineClass));
        if (targetedTabUnderlineSlide) jQuery(targetedTabUnderlineSlide[0]).css({
          left: this.offsetLeft,
          width: this.offsetWidth
        });
      });
    },
    resizeHolder: function resizeHolder(height) {
      var self = this;

      if (height) {
        this.$tabHolder.height(height);
        setTimeout(function () {
          self.$tabHolder.addClass('transition');
        }, 10);
      } else {
        self.$tabHolder.removeClass('transition').height('');
      }
    },
    switchTabs: function switchTabs() {
      var self = this;
      var $prevLink = this.$tabLinks.eq(this.prevTabIndex);
      var $nextLink = this.$tabLinks.eq(this.activeTabIndex);
      var $prevTab = this.getTab($prevLink);
      var $nextTab = this.getTab($nextLink);
      $prevTab.removeClass(this.options.activeClass);

      if (self.haveTabHolder()) {
        this.resizeHolder($prevTab.outerHeight());
      }

      setTimeout(function () {
        self.getClassTarget($prevLink).removeClass(self.options.activeClass);
        $prevTab.addClass(self.options.tabHiddenClass);
        $nextTab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);
        self.getClassTarget($nextLink).addClass(self.options.activeClass);

        if (self.haveTabHolder()) {
          self.resizeHolder($nextTab.outerHeight());
          setTimeout(function () {
            self.resizeHolder();
            self.prevTabIndex = self.activeTabIndex;
            self.makeCallback('onChange', self);
          }, self.options.animSpeed);
        } else {
          self.prevTabIndex = self.activeTabIndex;
        }
      }, this.options.autoHeight ? this.options.animSpeed : 1);
    },
    getClassTarget: function getClassTarget($link) {
      return this.options.addToParent ? $link.parent() : $link;
    },
    getActiveTab: function getActiveTab() {
      return this.getTab(this.$tabLinks.eq(this.activeTabIndex));
    },
    getTab: function getTab($link) {
      return $($link.attr(this.options.attrib));
    },
    haveTabHolder: function haveTabHolder() {
      return this.$tabHolder && this.$tabHolder.length;
    },
    destroy: function destroy() {
      var self = this;
      this.$tabLinks.off('.tabset').each(function () {
        var $link = $(this);
        self.getClassTarget($link).removeClass(self.options.activeClass);
        $($link.attr(self.options.attrib)).removeClass(self.options.activeClass + ' ' + self.options.tabHiddenClass);
      });
      this.$holder.removeData('Tabset');
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    }
  };

  $.fn.tabset = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    var options = $.extend({
      activeClass: 'active',
      addToParent: false,
      autoHeight: false,
      checkHash: false,
      defaultTab: true,
      animSpeed: 500,
      tabLinks: 'a',
      attrib: 'href',
      event: 'click',
      tabHiddenClass: 'js-tab-hidden',
      tabUnderlineClass: false
    }, opt);
    options.autoHeight = options.autoHeight;
    return this.each(function () {
      var $holder = jQuery(this);
      var instance = $holder.data('Tabset');

      if (_typeof(opt) === 'object' || typeof opt === 'undefined') {
        $holder.data('Tabset', new Tabset($holder, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
})(jQuery, jQuery(window));
/*
 * Responsive Layout helper
 */


window.ResponsiveHelper = function ($) {
  // init variables
  var handlers = [],
      prevWinWidth,
      win = $(window),
      nativeMatchMedia = false; // detect match media support

  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  } // prepare resize handler


  function resizeHandler() {
    var winWidth = win.width();

    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth; // loop through range groups

      $.each(handlers, function (index, rangeObject) {
        // disable current active area if needed
        $.each(rangeObject.data, function (property, item) {
          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;

            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        }); // enable areas that match current width

        $.each(rangeObject.data, function (property, item) {
          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;

            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
    }
  }

  win.bind('load resize orientationchange', resizeHandler); // test range

  function matchRange(r1, r2) {
    var mediaQueryString = '';

    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }

    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }

    return matchQuery(mediaQueryString, r1, r2);
  } // media query function


  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } else if (window.media) {
      return media.matchMedium(query);
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2;
    }
  } // range parser


  function parseRange(rangeStr) {
    var rangeData = rangeStr.split('..');
    var x1 = parseInt(rangeData[0], 10) || -Infinity;
    var x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort(function (a, b) {
      return a - b;
    });
  } // export public functions


  return {
    addRange: function addRange(ranges) {
      // parse data and add items to collection
      var result = {
        data: {}
      };
      $.each(ranges, function (property, data) {
        result.data[property] = {
          range: parseRange(property),
          enableCallback: data.on,
          disableCallback: data.off
        };
      });
      handlers.push(result); // call resizeHandler to recalculate all events

      prevWinWidth = null;
      resizeHandler();
    }
  };
}(jQuery);

},{}],17:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findById = exports.createForm = exports["default"] = void 0;

var _geoLocationService = require("impv/src/js/services/geo-location-service");

var _translateService = require("impv/src/js/services/translate-service");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isoCountries = {
  af: 'afghanistan',
  ax: 'aland islands',
  al: 'albania',
  dz: 'algeria',
  as: 'american samoa',
  ad: 'andorra',
  ao: 'angola',
  ai: 'anguilla',
  aq: 'antarctica',
  ag: 'antigua and barbuda',
  ar: 'argentina',
  am: 'armenia',
  aw: 'aruba',
  asc: 'ascension island',
  au: 'australia',
  at: 'austria',
  az: 'azerbaijan',
  bs: 'bahamas',
  bh: 'bahrain',
  bd: 'bangladesh',
  bb: 'barbados',
  by: 'belarus',
  be: 'belgium',
  bz: 'belize',
  bj: 'benin',
  bm: 'bermuda',
  bt: 'bhutan',
  bo: 'bolivia',
  bq: 'bonaire',
  ba: 'bosnia and herzegovina',
  bw: 'botswana',
  bv: 'bouvet island',
  br: 'brazil',
  io: 'british indian ocean territory',
  bn: 'brunei darussalam',
  bg: 'bulgaria',
  bf: 'burkina faso',
  bi: 'burundi',
  kh: 'cambodia',
  cm: 'cameroon',
  ca: 'canada',
  cv: 'cape verde',
  ky: 'cayman islands',
  cf: 'central african republic',
  td: 'chad',
  cl: 'chile',
  cn: 'china',
  cx: 'christmas island',
  cc: 'cocos (keeling) islands',
  co: 'colombia',
  km: 'comoros',
  cg: 'congo',
  cd: 'congo, dem. rep. of the',
  ck: 'cook islands',
  cr: 'costa rica',
  ci: 'ivory coast',
  hr: 'croatia',
  cu: 'cuba',
  cuw: 'curacao',
  cy: 'cyprus',
  cz: 'czech republic',
  dk: 'denmark',
  dj: 'djibouti',
  dm: 'dominica',
  "do": 'dominican republic',
  ec: 'ecuador',
  eg: 'egypt',
  sv: 'el salvador',
  gq: 'equatorial guinea',
  er: 'eritrea',
  ee: 'estonia',
  et: 'ethiopia',
  fk: 'falkland islands (malvinas)',
  fo: 'faroe islands',
  fj: 'fiji',
  fi: 'finland',
  fr: 'france',
  gf: 'french guiana',
  pf: 'french polynesia',
  tf: 'french southern territories',
  ga: 'gabon',
  gm: 'gambia',
  ge: 'georgia',
  de: 'germany',
  gh: 'ghana',
  gi: 'gibraltar',
  gr: 'greece',
  gl: 'greenland',
  gd: 'grenada',
  gp: 'guadeloupe',
  gu: 'guam',
  gt: 'guatemala',
  gg: 'guernsey',
  gn: 'guinea',
  gw: 'guinea-bissau',
  gy: 'guyana',
  ht: 'haiti',
  hm: 'heard island & mcdonald islands',
  va: 'holy see (vatican city state)',
  hn: 'honduras',
  hk: 'hong kong',
  hu: 'hungary',
  is: 'iceland',
  "in": 'india',
  id: 'indonesia',
  ir: 'iran, islamic republic of',
  iq: 'iraq',
  ie: 'ireland',
  im: 'isle of man',
  il: 'israel',
  it: 'italy',
  jm: 'jamaica',
  jp: 'japan',
  je: 'jersey',
  jo: 'jordan',
  kz: 'kazakhstan',
  ke: 'kenya',
  ki: 'kiribati',
  xk: 'kosovo',
  kw: 'kuwait',
  kg: 'kyrgyzstan',
  la: 'lao',
  lv: 'latvia',
  lb: 'lebanon',
  ls: 'lesotho',
  lr: 'liberia',
  ly: 'libyan arab jamahiriya',
  li: 'liechtenstein',
  lt: 'lithuania',
  lu: 'luxembourg',
  mo: 'macao',
  mk: 'macedonia',
  mg: 'madagascar',
  mw: 'malawi',
  my: 'malaysia',
  mv: 'maldives',
  ml: 'mali',
  mt: 'malta',
  mh: 'marshall islands',
  mq: 'martinique',
  mr: 'mauritania',
  mu: 'mauritius',
  yt: 'mayotte',
  mx: 'mexico',
  fm: 'micronesia, federated states of',
  md: 'moldova',
  mc: 'monaco',
  mn: 'mongolia',
  me: 'montenegro',
  ms: 'montserrat',
  ma: 'morocco',
  mz: 'mozambique',
  mm: 'myanmar',
  na: 'namibia',
  nr: 'nauru',
  np: 'nepal',
  nl: 'netherlands',
  an: 'netherlands antilles',
  nc: 'new caledonia',
  nz: 'new zealand',
  ni: 'nicaragua',
  ne: 'niger',
  ng: 'nigeria',
  nu: 'niue',
  nf: 'norfolk island',
  kr: 'north norea',
  mp: 'northern mariana islands',
  no: 'norway',
  om: 'oman',
  pk: 'pakistan',
  pw: 'palau',
  ps: 'palestinian territory',
  pa: 'panama',
  pg: 'papua new guinea',
  py: 'paraguay',
  pe: 'peru',
  ph: 'philippines',
  pn: 'pitcairn',
  pl: 'poland',
  pt: 'portugal',
  pr: 'puerto rico',
  qa: 'qatar',
  re: 'reunion',
  ro: 'romania',
  ru: 'russian federation',
  rw: 'rwanda',
  bl: 'saint barthelemy',
  sh: 'saint helena',
  kn: 'saint kitts and nevis',
  lc: 'saint lucia',
  mf: 'saint martin',
  pm: 'saint pierre and miquelon',
  vc: 'saint vincent and grenadines',
  ws: 'samoa',
  sm: 'san marino',
  st: 'sao tome and principe',
  sa: 'saudi arabia',
  sn: 'senegal',
  rs: 'serbia',
  sc: 'seychelles',
  sl: 'sierra leone',
  sg: 'singapore',
  sx: 'sint maartin (dutch part)',
  sk: 'slovakia',
  si: 'slovenia',
  sb: 'solomon islands',
  so: 'somalia',
  za: 'south africa',
  gs: 'south georgia and sandwich islands',
  kp: 'south korea',
  sd: 'sudan',
  es: 'spain',
  lk: 'sri lanka',
  sr: 'suriname',
  sj: 'svalbard and jan mayen',
  sz: 'swaziland',
  se: 'sweden',
  ch: 'switzerland',
  sy: 'syrian arab republic',
  tw: 'taiwan',
  tj: 'tajikistan',
  tz: 'tanzania',
  th: 'thailand',
  tl: 'timor-leste',
  tg: 'togo',
  tk: 'tokelau',
  to: 'tonga',
  tt: 'trinidad and tobago',
  tn: 'tunisia',
  tr: 'turkey',
  tm: 'turkmenistan',
  tc: 'turks and caicos islands',
  tv: 'tuvalu',
  ug: 'uganda',
  ua: 'ukraine',
  ae: 'united arab emirates',
  gb: 'united kingdom',
  us: 'united states',
  um: 'united states minor outlying islands',
  uy: 'uruguay',
  uz: 'uzbekistan',
  vu: 'vanuatu',
  ve: 'venezuela',
  vn: 'vietnam',
  vg: 'virgin islands, british',
  vi: 'virgin islands, u.s.',
  wf: 'wallis and futuna',
  eh: 'western sahara',
  ye: 'yemen',
  zm: 'zambia',
  zw: 'zimbabwe'
};
var emails = ['gamil.com', 'gmail.co', 'gmail.org', 'gmail.com', 'aol.com', 'att.net', 'comcast.net', 'facebook.com', 'gmx.com', 'googlemail.com', 'google.com', 'hotmail.com', 'hotmail.co.uk', 'mac.com', 'me.com', 'mail.com', 'msn.com', 'live.com', 'sbcglobal.net', 'verizon.net', 'yahoo.com', 'yahoo.co.uk', 'email.com', 'fastmail.fm', 'games.com ', 'gmx.net', 'hush.com', 'hushmail.com', 'icloud.com', 'iname.com', 'inbox.com', 'lavabit.com', 'love.com ', 'outlook.com', 'pobox.com', 'protonmail.ch', 'protonmail.com', 'tutanota.de', 'tutanota.com', 'tutamail.com', 'tuta.io', 'keemail.me', 'rocketmail.com ', 'safe-mail.net', 'wow.com ', 'ygm.com ', 'ymail.com ', 'zoho.com', 'yandex.com', 'bellsouth.net', 'charter.net', 'cox.net', 'earthlink.net', 'juno.com', 'btinternet.com', 'virginmedia.com', 'blueyonder.co.uk', 'freeserve.co.uk', 'live.co.uk', 'ntlworld.com', 'o2.co.uk', 'orange.net', 'sky.com', 'talktalk.co.uk', 'tiscali.co.uk', 'virgin.net', 'wanadoo.co.uk', 'bt.com', 'sina.com', 'sina.cn', 'qq.com', 'naver.com', 'hanmail.net', 'daum.net', 'nate.com', 'yahoo.co.jp', 'yahoo.co.kr', 'yahoo.co.id', 'yahoo.co.in', 'yahoo.com.sg', 'yahoo.com.ph', '163.com', 'yeah.net', '126.com', '21cn.com', 'aliyun.com', 'foxmail.com', 'hotmail.fr', 'live.fr', 'laposte.net', 'yahoo.fr', 'wanadoo.fr', 'orange.fr', 'gmx.fr', 'sfr.fr', 'neuf.fr', 'free.fr', 'gmx.de', 'hotmail.de', 'live.de', 'online.de', 't-online.de ', 'web.de', 'yahoo.de', 'libero.it', 'virgilio.it', 'hotmail.it', 'aol.it', 'tiscali.it', 'alice.it', 'live.it', 'yahoo.it', 'email.it', 'tin.it', 'poste.it', 'teletu.it', 'mail.ru', 'rambler.ru', 'yandex.ru', 'ya.ru', 'list.ru', 'hotmail.be', 'live.be', 'skynet.be', 'voo.be', 'tvcablenet.be', 'telenet.be', 'hotmail.com.ar', 'live.com.ar', 'yahoo.com.ar', 'fibertel.com.ar', 'speedy.com.ar', 'arnet.com.ar', 'yahoo.com.mx', 'live.com.mx', 'hotmail.es', 'hotmail.com.mx', 'prodigy.net.mx', 'yahoo.ca', 'hotmail.ca', 'bell.net', 'shaw.ca', 'sympatico.ca', 'rogers.com', 'yahoo.com.br', 'hotmail.com.br', 'outlook.com.br', 'uol.com.br', 'bol.com.br', 'terra.com.br', 'ig.com.br', 'itelefonica.com.br', 'r7.com', 'zipmail.com.br', 'globo.com', 'globomail.com', 'oi.com.br'];

var getCountryCodeFromName = function getCountryCodeFromName(countryName) {
  return Object.keys(isoCountries).find(function (key) {
    return isoCountries[key] === countryName;
  });
}; // TODO: move the setting to marketo config file


var MARKETO_SERVER_URL = '//go.imperva.com';
var MARKETO_APP_KEY = '727-WRL-406';
var marketoForms = global.marketoForms = global.marketoForms || {};
var siteUrl = location.protocol + '//' + location.host;

var MarketoForm =
/*#__PURE__*/
function () {
  function MarketoForm(formId) {
    var formArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var elem = arguments.length > 2 ? arguments[2] : undefined;
    var runNextFormFn = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, MarketoForm);

    this.uuid = formArgs.uuid || parseInt(Math.random() * 10000);
    this.uniqueIdPostfix = '_' + this.uuid;
    this.formId = formId;
    this.formArgs = formArgs;
    this.runNextFormFn = runNextFormFn;
    this.cbs = [];
    this.onSubmitCbs = [];
    this.onValidateCbs = [];
    this.pressOnEnterTimer = null;
    this.clickOnSubmitTimer = null;
    this.keyEnterPressed = false;
    this.submitBtnClicked = false;
    this.elem = elem;
    this.buttonText = this.getFormElem(this.form).find('.mktoButtonWrap button[type="submit"]').text();

    if (!this.elem) {
      console.error('MarketoForm:constructor missing elem param for form ID ', this.formId);
    }

    this.modifyElementsId();
    this.setupMarketoForm(formArgs);
    this.createForm();
    this.sendValidate();
    this.sendSubmit();
  }

  _createClass(MarketoForm, [{
    key: "createForm",
    value: function () {
      var _createForm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.elem) {
                  $(this.elem).attr('id', "mktoForm_".concat(this.formId));
                }

                try {
                  if ('MktoForms2' in window) {
                    MktoForms2.loadForm(MARKETO_SERVER_URL, MARKETO_APP_KEY, this.formId, function (form) {
                      _this.form = form;
                      _this.formElem = _this.getFormElem(form);

                      _this.formElem.attr('id', '');

                      _this.formElem.addClass('mkto-loaded');

                      _this.isHtmlTemplate = $('.mktoTemplateBox', _this.formElem).length > 0;

                      if (_this.isHtmlTemplate) {
                        _this.setHtmlTemplate();
                      }

                      _this.fireEvent();

                      if (typeof _this.runNextFormFn === 'function') {
                        _this.runNextFormFn();
                      }

                      var formLoadedEvt = new CustomEvent('mktoFormLoaded', {
                        detail: _this.formElem.attr('data-form-id')
                      });

                      if ($(_this.formElem).length) {
                        $(_this.formElem)[0].dispatchEvent(formLoadedEvt);
                      }
                    }); // console.log(`register MktoForm id ${this.formId}`);
                  } else {
                    console.error('MktoForms2 is not define');
                  }
                } catch (error) {
                  console.error('Error in class MarketoForm', error);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createForm() {
        return _createForm.apply(this, arguments);
      }

      return createForm;
    }()
  }, {
    key: "snapShotValidation",
    value: function snapShotValidation() {
      var _this2 = this;

      this.onSuccess(function (form) {
        var dataToSend = {};
        var formElem = $(form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this2.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['name'] = (formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        dataToSend['telephone'] = formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['email'] = formElem.find("#Email".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['state'] = formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['jobTitle'] = formElem.find("#Title".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['company'] = formElem.find("#Company".concat(_this2.uniqueIdPostfix)).val();
        var eULAConsent = formElem.find($("[name=\"eULAConsent\"]"));
        dataToSend['eULAConsent'] = eULAConsent.prop('checked');
        dataToSend['eULAConsent_copy'] = eULAConsent.next().html();
        var countryInput = formElem.find("#Country".concat(_this2.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        dataToSend['country'] = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        $.ajax({
          type: 'POST',
          url: siteUrl + '/wp-json/imperva_snapshot/v1/register/',
          data: dataToSend,
          async: false,
          dataType: 'json',
          success: function success(data) {
            var response = $.parseJSON(data);

            if (response[0].includes('200')) {
              window.location.assign('/resources/snapshot-thank-you/');
            } else {
              window.location.assign('/resources/snapshot-problem/');
            }
          },
          error: function error() {
            window.location.assign('/resources/snapshot-problem/');
          }
        });
        return false;
      });
    }
  }, {
    key: "modifyElementsId",
    value: function modifyElementsId() {
      var _this3 = this;

      this.onLoad(function (form) {
        var formElem = _this3.getFormElem(form);

        if (formElem.length) {
          var fields = formElem.find('input, select, textarea');
          var labels = formElem.find('label');
          fields.each(function (i, el) {
            var $el = $(el);
            var id = $el.attr('id');

            if (id) {
              $el.attr('id', id + _this3.uniqueIdPostfix);
            }
          });
          labels.each(function (i, el) {
            var $el = $(el);
            var labelFor = $el.attr('for');

            if (labelFor) {
              $el.attr('for', labelFor + _this3.uniqueIdPostfix);
            }
          });
        }
      });
    }
  }, {
    key: "eCustomsValidation",
    value: function eCustomsValidation() {
      var _this4 = this;

      var thankYouUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.onSubmit(function (_form) {
        var formElem = $(_form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this4.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this4.uniqueIdPostfix)).val();

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (FirstName.includes(' ') || FirstName.includes('test'))) {
          _form.setErrorMessage('FirstName', 'please enter a valid name');

          return false;
        }

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (LastName.includes(' ') || LastName.includes('test'))) {
          _form.setErrorMessage('LastName', 'please enter a valid name');

          return false;
        }

        var fullName = (formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        var Phone = formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val().split('-').join('') : '';
        var Email = formElem.find("#Email".concat(_this4.uniqueIdPostfix)).val();
        var State = formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() : '';
        var Title = formElem.find("#Title".concat(_this4.uniqueIdPostfix)).val();
        var Company = formElem.find("#Company".concat(_this4.uniqueIdPostfix)).val().replace(' ', '%20');
        var countryInput = formElem.find("#Country".concat(_this4.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        var Country = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        var url = siteUrl + "/wp-json/ecustoms_screening/v1/formID/".concat(_this4.formId, "?email=").concat(Email, "&name=").concat(fullName, "&telephone=").concat(Phone, "&jobTitle=").concat(Title, "&country=").concat(Country).concat(State, "&company=").concat(Company);
        var approve = false;
        var locationAssign = false;
        $.ajax({
          url: url,
          async: false,
          dataType: 'json',
          success: function success(response) {
            if (response != null && response.approved) {
              approve = true;

              if (thankYouUrl != null) {
                locationAssign = thankYouUrl;
              }
            } else {
              if (response === null) {
                console.log('eCustoms not available');
              }

              locationAssign = '/resources/free-tools-thank-you/';
              approve = false;
            }
          }
        });
        _this4.location_assign = locationAssign;
        return approve;
      });
    }
  }, {
    key: "fireEvent",
    value: function fireEvent() {
      var _this5 = this;

      if (this.cbs) {
        this.cbs.forEach(function (cb) {
          return cb(_this5.form);
        });
      }
    }
  }, {
    key: "onLoad",
    value: function onLoad(cb) {
      if (typeof cb === 'function') {
        if (this.form) {
          cb(this.form);
        } else {
          if (!this.cbs) {
            this.cbs = [];
          }

          this.cbs.push(cb);
        }
      }

      return this;
    }
    /**
     * register for input/s events
     * @param {string} eventNames
     * the events name to register
     * cab be multy event etc. 'change, input'
     * @param {string|function} inputName
     * if inputName is string ==> register for specific input | Else: if inputName is function => register for all inputs
     * @param {?function} cb
     * the callback function for this events
     * @return {MarketoForm} to chaining functions
     */

  }, {
    key: "registerEvent",
    value: function registerEvent(eventNames, inputName, cb) {
      var _this6 = this;

      if (typeof inputName === 'function') {
        cb = inputName;
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              $(formElem).on(eventName, "input, textarea, select", cb);
            });
          }
        });
      } else if (inputName && typeof cb === 'function') {
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              // console.log(
              //   `register event ${eventName} to elem ${inputName}`,
              //   $(`input[name="${inputName}"], textarea[name="${inputName}"], select[name="${inputName}"]`, formElem).data('events')
              // );
              $(formElem).on(eventName, "input[name=\"".concat(inputName, "\"], textarea[name=\"").concat(inputName, "\"], select[name=\"").concat(inputName, "\"]"), cb);
            });
          }
        });
      }

      return this;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(cb) {
      var _this7 = this;

      if (typeof cb === 'function') {
        this.onLoad(function (form) {
          return form.onSuccess(function (values, followUpUrl) {
            var form_block = document.querySelector('.form-block');
            var form_wrap = document.querySelector('.form-section .form-wrapper');

            if (form_wrap && form_wrap.classList.contains('form-block-class')) {
              form_block.classList.add('form-block-success');
            }

            return cb(_this7, values, followUpUrl);
          });
        });
      }

      return this;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(cb) {
      if (typeof cb === 'function') {
        this.onSubmitCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendSubmit",
    value: function sendSubmit() {
      var _this8 = this;

      this.onLoad(function (form) {
        return form.onSubmit(function (nativeValid) {
          var originalText = _this8.getButtonText(form);

          _this8.changeButtonText('Please wait', form);

          _this8.setButtonDisabled(form);

          var approvalsSubmit = [];

          _this8.onSubmitCbs.forEach(function (cb) {
            approvalsSubmit.push(cb(_this8));
          });

          if (!approvalsSubmit.includes(false) && nativeValid) {
            form.submittable(true);

            if (_this8.location_assign) {
              window.location.assign(_this8.location_assign);
            }

            return true;
          }

          _this8.changeButtonText(originalText, form);

          _this8.setButtonEnable(form);

          form.submittable(false);

          if (_this8.location_assign) {
            window.location.assign(_this8.location_assign);
          }

          return false;
        });
      });
    }
  }, {
    key: "onValidate",
    value: function onValidate(cb) {
      if (typeof cb === 'function') {
        this.onValidateCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendValidate",
    value: function sendValidate() {
      var _this9 = this;

      this.onLoad(function (form) {
        return form.onValidate(function (nativeValid) {
          var approvalsValidate = [];

          _this9.onValidateCbs.forEach(function (cb) {
            approvalsValidate.push(cb(_this9));
          });

          if (!approvalsValidate.includes(false) && nativeValid) {
            form.submittable(true);
            return true;
          }

          form.submittable(false);
          return false;
        });
      });
    }
  }, {
    key: "setButtonText",
    value: function setButtonText(text) {
      var _this10 = this;

      this.onLoad(function (form) {
        return _this10.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').text(text);
      });
      return this;
    }
  }, {
    key: "setButtonDisabled",
    value: function setButtonDisabled(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('disabled', true);
    }
  }, {
    key: "setButtonEnable",
    value: function setButtonEnable(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeAttr('disabled');
    }
  }, {
    key: "changeButtonText",
    value: function changeButtonText(text, form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html(text);
    }
  }, {
    key: "getButtonText",
    value: function getButtonText(form) {
      return this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html();
    }
  }, {
    key: "setButtonClasses",
    value: function setButtonClasses(classes) {
      var _this11 = this;

      if (classes) {
        this.onLoad(function (form) {
          return _this11.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeClass('mktoButton').addClass(classes);
        });
      }

      return this;
    }
  }, {
    key: "setButtonEvents",
    value: function setButtonEvents(events) {
      var _this12 = this;

      if (events) {
        this.onLoad(function (form) {
          Object.entries(events).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            console.log(value);

            _this12.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr(key, value);
          });
        });
      }

      return this;
    }
  }, {
    key: "setButtonTarget",
    value: function setButtonTarget(target) {
      var _this13 = this;

      if (target) {
        this.onLoad(function (form) {
          return _this13.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('target', target);
        });
      }

      return this;
    }
  }, {
    key: "setValues",
    value: function setValues(values, cbFn) {
      this.onLoad(function (form) {
        form.setValues(values);

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "hasOption",
    value: function hasOption(name, value) {
      var formElem = this.formElem;
      if (!formElem) return false;
      var option = formElem.find("[name=\"".concat(name, "\"] option[value=\"").concat(value, "\"]"));
      return option.length > 0;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(field, value) {
      field.val(value);
    }
  }, {
    key: "setValue",
    value: function setValue(name, value, cbFn) {
      var _this14 = this;

      this.onLoad(function (form) {
        try {
          form.setValues(_defineProperty({}, name, value));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Faild to set form field value', {
            field: name,
            value: value
          });
        }

        var formElem = _this14.getFormElem(form);

        var input = $("[name=\"".concat(name, "\"]"), formElem);

        if (input && input.is('select')) {
          var option = input.find("option[value=\"".concat(value, "\"]"));

          if (option.length > 0) {
            option.attr('selected', 'selected');
          }
        }

        if (input && input.is(':visible')) {
          // fire change and blur event to trigger the validations
          input.change();
          input.blur();
        }

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "setThankyouText",
    value: function setThankyouText(html) {
      var _this15 = this;

      if (html) {
        this.onSuccess(function () {
          var formElem = _this15.getFormElem();

          $(formElem).hide();
          var thankyouDiv = "\n          <div id=\"marketo_form_thankyou_".concat(_this15.formId, "\" class=\"marketo-form-thankyou-message\">\n            ").concat(html, "\n          </div>\n        ");
          $(formElem).parent().append(thankyouDiv);
          return false;
        });
      }
    }
  }, {
    key: "setThankyouUrl",
    value: function setThankyouUrl(url) {
      if (url) {
        this.onSuccess(function () {
          window.location.assign(url);
          return false;
        });
      }

      return this;
    }
  }, {
    key: "getFormElem",
    value: function getFormElem(form) {
      if (this.elem) {
        return $(this.elem);
      } else if (form) {
        return form.getFormElem();
      } else if (this.form) {
        return this.form.getFormElem();
      }

      return null;
    }
  }, {
    key: "getField",
    value: function getField(name) {
      var _this16 = this;

      return new Promise(function (resolve) {
        _this16.onLoad(function (form) {
          var formElem = _this16.getFormElem(form);

          var input = $("[name=\"".concat(name, "\"]"), formElem);
          resolve(input);
        });
      });
    }
  }, {
    key: "getValue",
    value: function getValue(name) {
      var _this17 = this;

      return new Promise(function (resolve) {
        _this17.getValues().then(function (vals) {
          resolve(vals[name]);
        });
      });
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _this18 = this;

      return new Promise(function (resolve) {
        _this18.onLoad(function (form) {
          resolve(form.getValues());
        });
      });
    }
  }, {
    key: "setLables",
    value: function setLables(lables) {
      var _this19 = this;

      var keys = Object.keys(lables);
      keys.forEach(function (key) {
        _this19.setLable(key, lables[key]);
      });
      return this;
    }
  }, {
    key: "setAutoLables",
    value: function setAutoLables() {
      var _this20 = this;

      this.onLoad(function (form) {
        var formElem = _this20.getFormElem(form);

        var inputs = $("[name]", formElem);
        var labels = {};
        inputs && inputs.each(function (_, el) {
          if ($(el).prop('nodeName') !== 'SELECT' && $(el).attr('type') !== 'checkbox' && $(el).attr('autoLables') !== 'false') {
            var name = $(el).attr('name');
            var id = $(el).attr('id');
            var placeholder = $(el).attr('placeholder');
            var label = placeholder || name;

            if (id && label) {
              labels[id] = label;
              $(el).attr('placeholder', label === 'FirstName' ? 'First name' : label === 'LastName' ? 'Last name' : label);
            }
          }
        });

        if (labels) {
          _this20.setLables(labels);
        }
      });
      return this;
    }
  }, {
    key: "setLable",
    value: function setLable(id, text) {
      var _this21 = this;

      this.onLoad(function (form) {
        var formElem = _this21.getFormElem(form);

        var label = $("label[for=\"".concat(id, "\"]"), formElem);
        label.text(text);
      });
      return this;
    }
  }, {
    key: "hideField",
    value: function hideField(name, duration) {
      var _this22 = this;

      this.onLoad(function (form) {
        var formElem = _this22.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.hide(duration);
        }
      });
      return this;
    }
  }, {
    key: "hasField",
    value: function hasField(name) {
      return this.getField(name).then(function (input) {
        return input.length > 0;
      });
    }
  }, {
    key: "showField",
    value: function showField(name, duration) {
      var _this23 = this;

      this.onLoad(function (form) {
        var formElem = _this23.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.show(duration);
        }
      });
      return this;
    }
  }, {
    key: "setErrorMessage",
    value: function setErrorMessage(fieldName, error) {
      var _this24 = this;

      var scrollTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.onLoad(function (form) {
        var formElem = _this24.getFormElem(form);

        var input = $("[name=\"".concat(fieldName, "\"]"), formElem);
        var field = $(input).parents('.mktoFieldWrap:first');

        if (error) {
          input.removeClass('mktoValid');
          input.addClass('mktoInvalid');
          input.siblings('.mktoError').show();
          field.addClass('mktoInvalidField');
        } else {
          input.removeClass('mktoInvalid');
          field.removeClass('mktoInvalidField');
        }

        form.submittable(false);
        form.showErrorMessage(error, input ? MktoForms2.$(input.get(0)) : null); // scroll into invalid input

        if (scrollTo && !_this24.formArgs['doNotScrollOnError']) {
          var top = $(formElem).offset().top;
          var notInModal = !formElem.closest('.modal').length;

          if (notInModal) {
            var header = $('#header');
            top -= header.outerHeight();
            window.scroll({
              top: top,
              left: 0,
              behavior: 'smooth'
            });
          }
        }
      });
      return this;
    }
    /**
     * split the full name to Firstname and LastName
     * @param {string} fullName fullname input value
     * @return {{firstName, lastName}} splitedFullName
     */

  }, {
    key: "splitFullName",
    value: function splitFullName(fullName) {
      /**
       * capitalize all word in given line
       * @param {string} text
       * the line text will be capitalize
       * @example
       * input: "shalom s. tuby"
       * output: "Shalom S. Tuby"
       * @return {string} capitalize all word in given line
       */
      var capitalize = function capitalize(text) {
        return text.toLowerCase().split(' ').map(function (s) {
          return s.charAt(0).toUpperCase() + s.substring(1);
        }).join(' ');
      };

      fullName = fullName.trim();

      if (!fullName) {
        return {};
      } // remove duplicate spaces


      fullName = fullName.replace(/\s{2,}/g, ' ');
      var split = '';

      if (fullName.includes('　')) {
        split = fullName.split('　');
      } else {
        split = fullName.split(' ');
      }

      if (split.length) {
        var firstName = split[0];
        var lastName = split[1] ? split.slice(1).join(' ') : '';
        firstName = capitalize(firstName);
        lastName = capitalize(lastName);
        return {
          firstName: firstName,
          lastName: lastName
        };
      }

      return {};
    }
  }, {
    key: "sendEventOnNoCountry",
    value: function sendEventOnNoCountry() {
      var dataLayerToSend = {
        event: 'GAevent',
        eventCategory: 'country field',
        eventAction: 'view',
        eventLabel: 'request demo form'
      };

      if (!global.dataLayer) {
        global.dataLayer = [];
      }

      global.dataLayer.push(dataLayerToSend);
    }
  }, {
    key: "prePopulatedCountry",
    value: function prePopulatedCountry() {
      var _this25 = this;

      // console.log('prePopulatedCountry for ', this.formId);
      this.hideField('Country').registerEvent('change', 'Country', function (event) {
        var inputElem = $(event.target);
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          _this25.setLable('State', 'State');

          _this25.getField('State').then(function (input) {
            var parent = $(input).parents('.mktoFieldWrap:first');
            var inputType = 'select';
            parent.addClass("inputType_".concat(inputType));
          });
        }
      }); // initial country and state from geo service

      (0, _geoLocationService.getGeoLocationData)().then(function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            state = _ref3.state,
            error = _ref3.error,
            status = _ref3.status,
            country = _ref3.country,
            stateCode = _ref3.stateCode,
            postalcode = _ref3.postalcode;

        // console.log('set GEO location for ', this.formId);
        if (!error && status == _geoLocationService.FINISH_STATUS && country) {
          _this25.onLoad(function () {
            // do not trigger auto Country if the form is in HtmlTemplate mode
            if (_this25.isHtmlTemplate) return; // set the country field from the GEO service

            if (country) {
              if (_this25.hasOption('Country', country)) {
                _this25.setValue('Country', country, function () {
                  _this25.hideField('Country');

                  if (_this25.formElem.find("[name=\"State\"]").length > 0) {
                    if (stateCode || state) {
                      if (_this25.hasOption('State', stateCode)) {
                        _this25.setValue('State', stateCode, function () {
                          return _this25.hideField('State');
                        });
                      } else if (_this25.hasOption('State', state)) {
                        _this25.setValue('State', state, function () {
                          return _this25.hideField('State');
                        });
                      } else {
                        _this25.showField('State');

                        _this25.showField('Country');

                        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


                        console.error('Failed to set State from GeoLocation service');
                      }
                    }
                  }
                });
              } else {
                _this25.sendEventOnNoCountry();

                _this25.showField('Country'); // eslint-disable-next-line no-console


                console.error('Failed to set Country from GeoLocation service');
              }
            } // set the postal_code field from the GEO service


            if (postalcode && postalcode != '0000') {
              _this25.setValue('PostalCode', postalcode);
            }
          });
        } else {
          _this25.sendEventOnNoCountry();

          _this25.showField('Country');

          console.error('Failed to set Country from GeoLocation service');
        }
      }, function (err) {
        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


        console.error('Failed to get country from GeoLocation Service', err);

        _this25.showField('Country');
      });
    }
  }, {
    key: "setHiddenFields",
    value: function setHiddenFields(hiddenFields) {
      var _this26 = this;

      if (hiddenFields) {
        $.each(hiddenFields, function (key, value) {
          var currentKey = key == 'form_type' ? 'formType' : key;

          _this26.setValue(currentKey, value);
        });
      }
    }
  }, {
    key: "setupMarketoForm",
    value: function setupMarketoForm(args) {
      var _this27 = this;

      //add support for error messages translation, get error messages from global var with translations if it exist
      var full_name_error_message = '';
      var email_error = 'Must be valid email. example@yourdomain.com';
      var phone_error = 'Must be a phone number. 503-555-1212';
      var company_error = 'This field is required.';
      var title_error = 'This field is required.';
      var department_error = 'This field is required.';
      var mobilephone_error = 'Must be a phone number. 503-555-1212';
      var firstname_error = 'This field is required.';
      var lastname_error = 'This field is required.';

      if (typeof error_messages !== 'undefined') {
        full_name_error_message = error_messages.full_name_error_message !== undefined ? error_messages.full_name_error_message : '';
        email_error = error_messages.email_error;
        phone_error = error_messages.phone_error;
        company_error = error_messages.company_error;
        title_error = error_messages.title_error;
        department_error = error_messages.department_error;
        mobilephone_error = error_messages.mobilephone_error;
        firstname_error = error_messages.firstname_error;
        lastname_error = error_messages.lastname_error;
      }

      var FullNameErrorMessage = full_name_error_message ? full_name_error_message : (0, _translateService.translate)('marketo_form.full_name_error_message', 'First Name and Last Name required');

      if (!args['no_auto_label']) {
        this.setAutoLables();
      }

      if (args['pre_populated_country']) {
        this.prePopulatedCountry();
      }

      if (args['button_label']) {
        this.setButtonText(args['button_label']);
      }

      if (args['button_class']) {
        this.setButtonClasses(args['button_class']);
      }

      if (args['button_events']) {
        this.setButtonEvents(args['button_events']);
      }

      if (args['thankyou_url']) {
        this.thankyouPageUrl = args['thankyou_url'];
        this.setThankyouUrl(args['thankyou_url']);
      }

      if (args['hidden_fields']) {
        this.setHiddenFields(args['hidden_fields']);
      }

      if (args['validate_fullname']) {
        this.registerEvent('input', 'fullNameTrendemon', function (event) {
          var fullName = event.target.value;

          var _this27$splitFullName = _this27.splitFullName(fullName),
              firstName = _this27$splitFullName.firstName,
              lastName = _this27$splitFullName.lastName;

          _this27.setValue('FirstName', firstName);

          _this27.setValue('LastName', lastName);
        });
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).registerEvent('blur', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(event) {
            var inputElem, parent, lastNameElem, lastName;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context2.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    _context2.next = 6;
                    return _this27.getField('LastName');

                  case 6:
                    lastNameElem = _context2.sent;
                    lastName = lastNameElem.val();

                    if (!lastName) {
                      setTimeout(function () {
                        inputElem.addClass('mktoInvalid');
                        inputElem.removeClass('mktoValid');
                        parent.addClass('mktoInvalidField');

                        _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
                      }, 0);
                    } else {
                      setTimeout(function () {
                        inputElem.removeClass('mktoInvalid');
                        parent.removeClass('mktoInvalidField');
                      }, 0);
                    }

                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }()).registerEvent('focusin', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref5 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(event) {
            var inputElem, parent;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context3.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    inputElem.removeClass('mktoInvalid');
                    parent.removeClass('mktoInvalidField'); //support error messages translation

                    if (typeof error_messages !== 'undefined') {
                      _this27.onLoad(function (form) {
                        form.showErrorMessage(FullNameErrorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                      });
                    }

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2) {
            return _ref5.apply(this, arguments);
          };
        }());
      }

      if (args['validate_private_email_domain']) {
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).registerEvent('blur', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee4() {
          var inputElem, email, emailDomain;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context4.sent;
                  email = inputElem.val().toLowerCase();
                  emailDomain = email.split('@');

                  if ($.inArray(emailDomain[1], emails) !== -1) {
                    setTimeout(function () {
                      inputElem.addClass('mktoInvalid');
                      inputElem.removeClass('mktoValid');

                      _this27.setErrorMessage('Email', args['email_domain_error'], false);
                    }, 0);
                  } else {
                    setTimeout(function () {
                      inputElem.removeClass('mktoInvalid');
                    }, 0);
                  }

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))).registerEvent('focusin', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5() {
          var inputElem;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context5.sent;
                  inputElem.removeClass('mktoInvalid');

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })));
      }

      var validateNotEmpty = function validateNotEmpty(str) {
        return str.length;
      };

      var validateEmail = function validateEmail(str) {
        var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return re.test(String(str).toLowerCase());
      };

      var validateNum = function validateNum(str) {
        return validateNotEmpty(str) && /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/.test(str);
      };

      var getValidatorByName = function getValidatorByName(name) {
        var meta = {
          Email: validateEmail,
          Phone: validateNum,
          Company: validateNotEmpty,
          Title: validateNotEmpty,
          MobilePhone: validateNum
        };
        return meta[name] || validateNotEmpty;
      };

      var inputsOnBlur = function inputsOnBlur(e, errorMessage) {
        var inputElem = jQuery(e.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();
        var validatorFn = getValidatorByName(inputElem.attr('name'));

        if (!validatorFn(val)) {
          setTimeout(function () {
            inputElem.addClass('mktoInvalid');
            inputElem.removeClass('mktoValid');
            parent.addClass('mktoInvalidField');

            _this27.setErrorMessage(inputElem.attr('name'), errorMessage, false);
          }, 0);
        } else {
          setTimeout(function () {
            inputElem.removeClass('mktoInvalid');
            parent.removeClass('mktoInvalidField');
          }, 0);
        }
      };

      var inputsOnFoucsIn =
      /*#__PURE__*/
      function () {
        var _ref8 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee6(e, errorMessage) {
          var inputElem, parent;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  inputElem = jQuery(e.target);
                  parent = inputElem.parents('.mktoFieldWrap:first');
                  inputElem.removeClass('mktoInvalid');
                  parent.removeClass('mktoInvalidField'); //support error messages translation

                  if (typeof error_messages !== 'undefined') {
                    _this27.onLoad(function (form) {
                      form.showErrorMessage(errorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                    });
                  }

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function inputsOnFoucsIn(_x3, _x4) {
          return _ref8.apply(this, arguments);
        };
      }();

      var inputsOnSubmit = function inputsOnSubmit(name, form, errorMessage) {
        if (typeof error_messages !== 'undefined') {
          var input = $("[name=\"".concat(name, "\"]"), form);
          var parent = input.parent();

          if (parent.hasClass('mktoFieldTouched') && parent.hasClass('mktoInvalidField')) {
            _this27.setErrorMessage(name, errorMessage, false);
          }
        }

        return true;
      };

      [['Email', args['email_invalid_error'] !== '' ? args['email_invalid_error'] : email_error], ['Phone', phone_error], ['Company', company_error], ['Title', title_error], ['Department', department_error], ['MobilePhone', mobilephone_error], ['FirstName', firstname_error], ['LastName', lastname_error]].forEach(function (field) {
        var name = field[0];
        var msg = field[1];

        _this27.registerEvent('blur', name, function (e) {
          inputsOnBlur(e, msg);
        });

        _this27.registerEvent('focusin', name, function (e) {
          inputsOnFoucsIn(e, msg);
        });

        _this27.onLoad(function (form) {
          var formElem = _this27.getFormElem(form);

          formElem.on('submit', {
            name: name,
            formElem: formElem,
            msg: msg
          }, function (e) {
            inputsOnSubmit(e.data.name, e.data.formElem, e.data.msg);
          });
        });
      }); // lets to know if submit was triggered by 'ENTER'

      var onKeyPress = function onKeyPress(e) {
        var key = e.key;

        if (key.toUpperCase().trim() === 'ENTER') {
          _this27.keyEnterPressed = true;
          clearTimeout(_this27.pressOnEnterTimer);
          _this27.pressOnEnterTimer = setTimeout(function () {
            _this27.keyEnterPressed = false;
          }, 1000);
        }
      }; // lets to know if submit was triggered by click


      var clickOnSubmitFn = function clickOnSubmitFn(e) {
        _this27.submitBtnClicked = true;
        clearTimeout(_this27.clickOnSubmitTimer);
        _this27.clickOnSubmitTimer = setTimeout(function () {
          _this27.submitBtnClicked = false;
        }, 1000);
      };

      this.onLoad(function (form) {
        var formElem = _this27.getFormElem(form);

        if (formElem.length) {
          var submitBtn = formElem.find('button[type="submit"]');
          submitBtn.on('click', clickOnSubmitFn);
        }

        document.addEventListener('keypress', onKeyPress);
      }); // remove error message for empty focused input

      this.onValidate(function (_form) {
        setTimeout(function (_form) {
          var $form = _this27.getFormElem(_form);

          var fullNameElem = $form.find('[name="fullNameTrendemon"]');
          var focusedElem = $(document.activeElement);

          var showEmptyMsg = function showEmptyMsg(name) {
            return _this27.setErrorMessage(name, '  ', false);
          }; // show empty error message when focused field is empty


          if (focusedElem.length && _this27.keyEnterPressed) {
            var focusedElemTagName = focusedElem[0].tagName.toUpperCase();
            var val = focusedElem.val();
            var valIsEmty = !val.length;

            if (valIsEmty && (focusedElemTagName === 'INPUT' || focusedElemTagName === 'SELECT' || focusedElemTagName === 'TEXTAREA')) {
              var name = focusedElem.attr('name');

              if (args['validate_fullname']) {
                if (!fullNameElem.val()) {
                  showEmptyMsg(name);
                }
              } else {
                showEmptyMsg(name);
              }

              return;
            }
          } // set error state if submit is clicked and field is empty


          if (args['validate_fullname'] && _this27.submitBtnClicked && !_this27.keyEnterPressed) {
            var lastNameElem = $form.find('[name="LastName"]');

            if (!fullNameElem.val() || !lastNameElem.val()) {
              var parent = fullNameElem.parents('.mktoFieldWrap:first');
              fullNameElem.addClass('mktoInvalid');
              fullNameElem.removeClass('mktoValid');
              parent.addClass('mktoInvalidField'); // className "mktoFieldTouched" needed for red border on the input

              parent.addClass('mktoFieldTouched');

              _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
            }
          }

          _this27.submitBtnClicked = false;
          _this27.keyEnterPressed = false;
        }, 30, _form);
      });
      this.onLoad(function (form) {
        // set the input type on mktoFieldWrap element
        var formElem = _this27.getFormElem(form);

        if (typeof field_labels !== 'undefined') {
          $('label', formElem).each(function (i, elem) {
            var label = $(elem);

            if (typeof field_labels[label.text()] !== 'undefined') {
              label.text(field_labels[label.text()]);
            }
          });
        }

        $('input,textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = $(elem).attr('type');
          parent.addClass("inputType_".concat(inputType));

          if (typeof field_labels !== 'undefined') {
            var input = elem;

            if (typeof field_labels[input.getAttribute('placeholder')] !== 'undefined') {
              input.setAttribute('placeholder', field_labels[input.getAttribute('placeholder')]);
            }
          }
        });
        $('textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'textarea';
          parent.addClass("inputType_".concat(inputType));
        });
        $('select', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'select';
          parent.addClass("inputType_".concat(inputType));

          if ($(elem).attr('autoLables') !== 'false') {
            parent.find('.mktoLabel').text(parent.find('option:first').text());
          }

          parent.find('option:first').text('Please choose');
        });
        /* Potential use for translating buttons, however a brute (overall) solution was found for Downloads in /themes/impv-resources/loop-templates/content-gated-ungated.php
        $('button', formElem).each((i, elem) => {
          const button_text = $(elem).html();
          if (typeof field_labels !== 'undefined') {
            if (field_labels[button_text] !== 'undefined') {
              $(elem).html( field_labels[button_text] );
            }
          }
        }); */
      }) // populate the input validation and focuse state to the parent div
      .registerEvent('focus blur', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        /**
         * inputElem.is(document.activeElement) is workaround to support focus on safari
         */

        if (inputElem.is(':focus') || inputElem.is(document.activeElement)) {
          parent.addClass('mktoFieldFocus');
        } else {
          parent.removeClass('mktoFieldFocus');
        }

        setTimeout(function () {
          if (inputElem.hasClass('mktoInvalid')) {
            parent.addClass('mktoInvalidField');
          } else {
            parent.removeClass('mktoInvalidField');
          }
        }, 0);
      }) // populate the input validation to the parent div
      .registerEvent('focusin keyup', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');

        if (inputElem.hasClass('mktoInvalid')) {
          parent.addClass('mktoInvalidField');
        } else {
          parent.removeClass('mktoInvalidField');
        }
      }).registerEvent('focusout', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first'); // for the first time the imput was touched

        parent.addClass('mktoFieldTouched');
      }).registerEvent('change', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          parent.addClass('mktoFieldFill');
        } else {
          parent.removeClass('mktoFieldFill');
        }
      });
    }
  }, {
    key: "setHtmlTemplate",
    value: function setHtmlTemplate() {
      $(this.formElem).addClass('html-template');
    }
  }], [{
    key: "register",
    value: function register() {
      // find forms
      var formNodes = _toConsumableArray(document.querySelectorAll('form.marketo-form')); // create list with unique ids


      this.formIds = formNodes.reduce(function (list, form) {
        var id = form.dataset.formId;

        if (id && list.indexOf(id) === -1) {
          list.push(id);
        }

        return list;
      }, []); // init marketo forms for each ID

      this.formIds.forEach(function (formId) {
        // find forms with current id
        var idForms = _toConsumableArray(document.querySelectorAll("form.marketo-form[data-form-id=\"".concat(formId, "\"]"))); // next form with the same ID will be loaded on callback that takes MktoForms2.loadForm function


        (function loadFormHandler(idForms) {
          if (idForms.length) {
            var formEl = idForms.shift();
            var nextFormFn = loadFormHandler.bind(null, _toConsumableArray(idForms));
            var index = formNodes.indexOf(formEl);
            registerForm(index, formEl, nextFormFn);
          }
        })(idForms);
      });

      function registerForm(idx, e, runNextFormFn) {
        var formArgs = {};
        $(e).data('index', idx);

        try {
          var formArgsKey = $(e).data('form-args');

          if (formArgsKey && formArgsKey in window) {
            formArgs = window[formArgsKey];
          }
        } catch (err) {
          console.error('Faild to parse form args from element data', err);
        }

        var getFormId = function getFormId(e) {
          if (formArgs) {
            if (formArgs.form_id) {
              return formArgs.form_id;
            }
          }

          var formId = $(e).data('form-id');

          if (!formId) {
            var elId = $(e).attr('id');

            if (elId) {
              var s = elId.split('_');

              if (s.length > 1) {
                formId = s.pop();
              }
            }
          }

          return formId;
        };

        var formId = getFormId(e);
        console.info('register marketo form', formId);

        if (!formArgs.uuid) {
          formArgs.uuid = parseInt(Math.random() * 10000);
        }

        if (formId) {
          var uuid = formArgs.uuid;
          $(e).attr('data-uuid', uuid); // if someone waiting to this form - fire event

          var instance = new MarketoForm(formId, formArgs, e, runNextFormFn);

          if (typeof marketoForms[formId] === 'function') {
            var cb = marketoForms[formId];
            marketoForms[uuid] = instance;
            cb(instance);
          } else {
            marketoForms[uuid] = instance;
          }
        }
      }
    }
  }, {
    key: "findById",
    value: function findById(formId) {
      return new Promise(function (resolve) {
        var found = Object.values(marketoForms).filter(function (m) {
          return m.formId == formId;
        });

        if (found && found.length > 0) {
          resolve(found[0]);
        } else {
          marketoForms[formId] = resolve;
        }
      });
    }
  }]);

  return MarketoForm;
}();

exports["default"] = MarketoForm;

var createForm = function createForm(formId) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var elem = arguments.length > 2 ? arguments[2] : undefined;
  return new MarketoForm(formId, args, elem);
};

exports.createForm = createForm;

var findById = function findById(formId) {
  return MarketoForm.findById(formId);
};

exports.findById = findById;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"impv/src/js/services/geo-location-service":21,"impv/src/js/services/translate-service":24}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var GOOGLE_GEOCODE_CLIENT_API_KEY = window.pageGlobalData.GOOGLE_GEOCODE_CLIENT_API_KEY;
var _default = {
  API_KEY: GOOGLE_GEOCODE_CLIENT_API_KEY,
  BASE_URL: 'https://www.googleapis.com/geolocation/v1/geolocate'
};
exports["default"] = _default;

},{}],19:[function(require,module,exports){
(function (global){
"use strict";

var _marketoForm = require("impv/src/js/components/marketo-form");

var _headerHoverHelper = _interopRequireDefault(require("./components/header-hover-helper"));

var _downloadHelper = _interopRequireDefault(require("./components/download-helper"));

var _headerHelpers = require("./components/header-helpers");

require("./components/jquery-tabs");

require("./components/jquery-sameheight");

require("./components/jquery-popup");

var _helpers = require("./main/helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

document.addEventListener('form2init', marketoFormActions);

function marketoFormActions() {
  $(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2() {
    var $formIDs;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            $formIDs = $('.modalformselements');
            $.each($formIDs, function (_, e) {
              var formId = $(e).val();
              $(
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee() {
                var form;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _marketoForm.findById)(formId);

                      case 2:
                        form = _context.sent;
                        form.hideField('Policy_Consent__c').registerEvent('focusout', 'fullNameTrendemon', function () {
                          if (!form.visited) {
                            form.visited = true;
                            form.showField('Policy_Consent__c', 400);
                          }
                        });
                        form.onSuccess(function (_) {
                          var formElem = form.form.getFormElem();
                          var $modal = $(formElem).closest('.modal');

                          if ($modal.length) {
                            var downloadUrl = $modal.attr('data-success-download-file');
                            var fileName = $modal.attr('data-success-file-name');
                            var redirectUrl = $modal.attr('data-success-redirect');

                            if (downloadUrl) {
                              // download file
                              (0, _downloadHelper["default"])(downloadUrl, fileName);
                            } else if (redirectUrl) {
                              // change page
                              window.location.href = redirectUrl;
                            } else {
                              showThankYou();
                            }
                          } else {
                            showThankYou();
                          }

                          function showThankYou() {
                            $(formElem).hide();
                            var formParent = $(formElem).parents('.form-side');
                            var thankyoutarget = '#' + $(e).attr('thankyoutarget');
                            $(thankyoutarget).show();
                            formParent.find('.pre-text').hide();
                          }

                          if ('dataLayer' in window) {
                            window.dataLayer.push({
                              event: 'VirtualPageview',
                              virtualPageURL: "'" + $(e).attr('virtualpageurl') + "'",
                              virtualPageTitle: "'" + $(e).attr('virtualpagetitle') + "'"
                            });
                          }

                          if ('hj' in window) {
                            //Hotjar Virtual Page View trigger.
                            hj('vpv', 'form-id ' + formId + 'submited' + $(e).attr('thankyoutarget'));
                          }

                          return false;
                        });

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            });

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
}

document.addEventListener('DOMContentLoaded', function () {
  prepareHeader();
  initHeaderScripts();
});

function prepareHeader() {
  (0, _headerHelpers.makeResponsiveHeaderTemplateNew)();
  (0, _headerHelpers.fullNameToLangCode)();
  (0, _headerHelpers.setHeaderHeight)();
  (0, _headerHelpers.setScreenWidth)().init();
}

var Header =
/*#__PURE__*/
function () {
  function Header() {
    _classCallCheck(this, Header);

    var self = this;
    jQuery(window).ready(function () {
      self.$winWidth = jQuery(window).width();
    });
    this.init();
  }

  _createClass(Header, [{
    key: "init",
    value: function init() {
      if (this.initIsIOS()) {
        document.documentElement.classList.add('is-ios');
      }

      this.addClssWithDrop();
      this.bigDropHelper();
      this.initMenu();
      this.initAffix();
      this.initLangSelect();
      this.setReadyState();
      this.initTabsDrop();
      this.initSameHeight();
      this.initPopupsDrop();
    }
  }, {
    key: "initMenu",
    value: function initMenu() {
      var pageHtml = document.documentElement;
      var navMain = document.getElementById('nav-main');
      var menuTopItems = navMain && navMain.querySelectorAll('.top-nav-items');
      var navOpener = document.querySelectorAll('.mobile-menu');
      var activeClassMenu = 'menu-open';
      var dropColumns = document.querySelectorAll('#nav-main .drop .col, #nav-main .full-width-drop .col');
      var apiHoverHelper = null;
      var accordionIstns = [];
      var setNavHeightInst = (0, _headerHelpers.setNavHeight)();
      var makeHoverDropInst = (0, _headerHelpers.makeHoverTBDropdown)(document.getElementById('choose-login'));
      var handleHeaderHoveringInst = (0, _headerHelpers.handleHeaderHovering)();

      var addClassByText = function addClassByText(items, opener) {
        if (items && items.length) {
          _toConsumableArray(items).forEach(function (el) {
            var link = el.querySelector(opener);

            if (link) {
              var openerText = link.innerText.trim().toLowerCase();

              if (openerText) {
                var result = openerText.split(' ').reduce(function (acc, curr, i) {
                  acc += i ? "-".concat(curr) : curr;
                  return acc;
                }, '');
                el.classList.add(result);
              }
            }
          });
        }
      }; // add collapse instances to list


      var createAccordions = function createAccordions() {
        accordionIstns.push((0, _headerHelpers.headerAccordion)({
          accParent: navMain,
          accItems: menuTopItems,
          openerSelector: '.opener',
          closeSelector: '.back-btn',
          dropSelector: '.full-width-drop, .drop-more'
        }));

        if (menuTopItems) {
          _toConsumableArray(menuTopItems).forEach(function (el) {
            var drop = el.querySelector('.drop-more');

            if (drop) {
              var items = drop.querySelectorAll('.subdrop');
              accordionIstns.push((0, _headerHelpers.headerAccordion)({
                accParent: drop,
                accItems: items,
                openerSelector: '.sub-opener',
                dropSelector: '.collapse-element'
              }));
            }
          });
        }
      };

      var linkClickInst = (0, _headerHelpers.navBarItemsClick)(); // createAccordions();

      _helpers.ResponsiveHelper.addRange(_defineProperty({
        '1200..': {
          on: function on() {
            apiHoverHelper = new _headerHoverHelper["default"](navMain, {
              itemsSelector: '.top-nav-items',
              dropSelector: '.drop, .full-width-drop',
              activeClass: 'open'
            }); // add open class to drop

            linkClickInst.init();
            handleHeaderHoveringInst.init();
          },
          off: function off() {
            if (apiHoverHelper && 'destroy' in apiHoverHelper) {
              apiHoverHelper.destroy();
            }

            linkClickInst.destroy();
            handleHeaderHoveringInst.destroy();
          }
        },
        // '..1199': {
        //   on: function() {
        //     accordionIstns.forEach(inst => {
        //       inst.init();
        //     });
        //   },
        //   off: function() {
        //     accordionIstns.forEach(inst => {
        //       inst.destroy();
        //     });
        //   }
        // },
        '..767': {
          on: function on() {
            // add cookie bar height to css --nav-height :root's variable
            setNavHeightInst.init();
          },
          off: function off() {
            setNavHeightInst.destroy();
          }
        }
      }, "1200..", {
        on: function on() {
          if (!(0, _headerHelpers.isTouchDevice)()) {
            makeHoverDropInst.init();
          }
        },
        off: function off() {
          makeHoverDropInst.destroy();
        }
      }));

      addClassByText(menuTopItems, '.opener');
      addClassByText(document.querySelectorAll('.full-width-drop .col'), '.sub-opener');

      _toConsumableArray(dropColumns).forEach(function (col) {
        if (!col.querySelector('ul')) {
          col.classList.add('col-witout-ul');
        }
      }); // burger menu


      if (navOpener) {
        _toConsumableArray(navOpener).forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.preventDefault();
            pageHtml.classList.toggle(activeClassMenu);
          });
        });
      }
    }
  }, {
    key: "addClssWithDrop",
    value: function addClssWithDrop() {
      var items = document.querySelectorAll('#header .top-nav-items');

      _toConsumableArray(items).forEach(function (item) {
        var drop = item.querySelector('.drop, .full-width-drop');

        if (drop) {
          item.classList.add('has-drop');
        }
      });
    }
  }, {
    key: "bigDropHelper",
    value: function bigDropHelper() {
      var drops = document.querySelectorAll('#header .full-width-drop');

      _toConsumableArray(drops).forEach(function (el) {
        var columns = el.querySelectorAll('.container-fluid > .row > .col');
        var columnsLen = columns.length;
        el.classList.add("drop-with-".concat(columnsLen, "-cols"));
      });
    }
  }, {
    key: "initAffix",
    value: function initAffix() {
      var evt = new Event('affixHeaderHeightChanged');

      try {
        jQuery(document).ready(function () {
          var prevHeight = 0;

          var toggleAffix = function toggleAffix(affixElement, scrollElement, wrapper) {
            var height = affixElement.outerHeight();
            var top = wrapper.offset().top + 55;

            if (scrollElement.scrollTop() >= top) {
              wrapper.height(height);
              affixElement.addClass('affix');
            } else {
              affixElement.removeClass('affix');
              wrapper.height('auto');
            }

            if (prevHeight !== height) {
              prevHeight = height;
              document.dispatchEvent(evt);
            }
          };

          jQuery('[data-spy="affix"]').each(function (i, e) {
            var ele = jQuery(e);
            var wrapper = jQuery('<div></div>');
            ele.before(wrapper);
            jQuery(window).on('scroll resize', function (e) {
              toggleAffix(ele, jQuery(e.currentTarget), wrapper);
            }); // init

            toggleAffix(ele, jQuery(window), wrapper);
          });
        });
      } catch (error) {
        console.error('Error in Header:initAffix function', error);
      }
    }
  }, {
    key: "initLangSelect",
    value: function initLangSelect() {
      var dropDownFunction = function dropDownFunction($dropDownElem, eventCatefory) {
        $dropDownElem.on('select_changed', function () {
          window.location = $dropDownElem.find('.dropdown-select-btn').attr('data-value');
          var event = 'GAevent';
          var eventCategory = eventCatefory;
          var eventAction = 'click';
          var eventLabel = $dropDownElem.find('.name').text();
          var dataLayerToSend = {
            event: event,
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: eventLabel
          };

          if (!global.dataLayer) {
            global.dataLayer = [];
          }

          global.dataLayer.push(dataLayerToSend);
        });
      };

      dropDownFunction($('#choose-login'), 'Top menu login');
      dropDownFunction($('#choose-lang'), 'Top menu lang');
      dropDownFunction($('#choose-lang-footer'), 'Bottom menu lang');
      dropDownFunction($('#choose-lang-footer-privacy'), 'Bottom menu lang');
    } // content tabs init

  }, {
    key: "initTabsDrop",
    value: function initTabsDrop() {
      _helpers.ResponsiveHelper.addRange({
        '1200..': {
          on: function on() {
            jQuery('.drop-tabset').tabset({
              tabLinks: 'a',
              addToParent: true,
              event: 'mouseenter',
              defaultTab: true
            });
          },
          off: function off() {
            jQuery('.drop-tabset').tabset('destroy');
          }
        }
      });
    } // align blocks height

  }, {
    key: "initSameHeight",
    value: function initSameHeight() {
      jQuery('.nav-top .drop').sameHeight({
        elements: '.subtitle',
        flexible: true,
        multiLine: true,
        biggestHeight: true
      });
      jQuery('.collapse-element').sameHeight({
        elements: '.subtitle',
        flexible: true,
        multiLine: true,
        biggestHeight: true
      });
    } // popups init

  }, {
    key: "initPopupsDrop",
    value: function initPopupsDrop() {
      _helpers.ResponsiveHelper.addRange({
        '..1199': {
          on: function on() {
            jQuery('.top-nav-items').contentPopupDrop({
              mode: 'click',
              popup: '.full-width-drop, .drop-more',
              btnOpen: '.opener',
              btnClose: '.back-btn',
              hideOnClickLink: false,
              hideOnClickOutside: false
            });
            jQuery('.subdrop').contentPopupDrop({
              mode: 'click',
              popup: '.collapse-element',
              btnOpen: '.sub-opener',
              btnClose: '.back-sub-btn',
              openClass: 'sub-active',
              hideOnClickLink: false,
              hideOnClickOutside: false,
              onShow: function onShow(flag, api) {
                api.holder.closest('.drop-more').addClass('subdrop-opened');
              },
              onHide: function onHide(flag, api) {
                api.holder.closest('.drop-more').removeClass('subdrop-opened');
              },
              onDestroy: function onDestroy(api) {
                api.holder.closest('.drop-more').removeClass('subdrop-opened');
              }
            });
          },
          off: function off() {
            jQuery('.top-nav-items').contentPopupDrop('destroy');
            jQuery('.subdrop').contentPopupDrop('destroy');
          }
        }
      });
    }
  }, {
    key: "setReadyState",
    value: function setReadyState() {
      var header = document.querySelector('#header');
      header.classList.add('is-ready-to-show');
    }
  }, {
    key: "initIsIOS",
    value: function initIsIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }
  }]);

  return Header;
}();

function initHeaderScripts() {
  return new Header();
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./components/download-helper":1,"./components/header-helpers":5,"./components/header-hover-helper":13,"./components/jquery-popup":14,"./components/jquery-sameheight":15,"./components/jquery-tabs":16,"./main/helpers":20,"impv/src/js/components/marketo-form":17}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = throttle;
exports.ResponsiveHelper = exports.toggleBetweenClass = void 0;

// getting the date in a regular WP REST API format (2017-09-09T05:19:04) and return it as "SEP 9 2017"
// export const getFormatedDate = postsPublishDate => {
//   let date = new Date(Date.parse(postsPublishDate));
//   let monthNames = [
//     "Jan", "Feb", "Mar",
//     "Apr", "May", "June", "July",
//     "Aug", "Sep", "Oct",
//     "Nov", "Dec"
//   ];
//   let day = date.getDate();
//   let monthIndex = date.getMonth();
//   let year = date.getFullYear();
//
//   return monthNames[monthIndex] + ' ' + year;
// };
var toggleBetweenClass = function toggleBetweenClass($element, defautClass, seconderyClass) {
  if ($element.hasClass(defautClass)) {
    $element.removeClass(defautClass).addClass(seconderyClass);
  } else if ($element.hasClass(seconderyClass)) {
    $element.removeClass(seconderyClass).addClass(defautClass);
  } else {
    // eslint-disable-next-line no-console
    console.info('None of the provided Classes is set for this element', $element);
  }
};

exports.toggleBetweenClass = toggleBetweenClass;

function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};

  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }

    return result;
  };
}

var ResponsiveHelper = function () {
  var handlers = [];
  var prevWinWidth;
  var nativeMatchMedia = false; // detect match media support

  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  } // prepare resize handler


  function resizeHandler() {
    var winWidth = window.innerWidth;

    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth; // loop through range groups

      handlers.forEach(function (rangeObject) {
        // disable current active area if needed
        Object.keys(rangeObject.data).map(function (key) {
          var item = rangeObject.data[key];

          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;

            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        }); // enable areas that match current width

        Object.keys(rangeObject.data).map(function (key) {
          var item = rangeObject.data[key];

          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;

            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
    }
  }

  ['load', 'resize', 'orientationchange'].forEach(function (e) {
    window.addEventListener(e, resizeHandler);
  }); // test range

  function matchRange(r1, r2) {
    var mediaQueryString = '';

    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }

    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }

    return matchQuery(mediaQueryString, r1, r2);
  } // media query function


  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } else if (window.media) {
      return media.matchMedium(query);
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2;
    }
  } // range parser


  function parseRange(rangeStr) {
    var rangeData = rangeStr.split('..');
    var x1 = parseInt(rangeData[0], 10) || -Infinity;
    var x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort(function (a, b) {
      return a - b;
    });
  } // export public functions


  return {
    addRange: function addRange(ranges) {
      // parse data and add items to collection
      var result = {
        data: {}
      };
      Object.keys(ranges).map(function (key) {
        result.data[key] = {
          range: parseRange(key),
          enableCallback: ranges[key].on,
          disableCallback: ranges[key].off
        };
      });
      handlers.push(result); // call resizeHandler to recalculate all events

      prevWinWidth = null;
      resizeHandler();
    }
  };
}();

exports.ResponsiveHelper = ResponsiveHelper;

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ERROR_STATUS = exports.FINISH_STATUS = exports.IN_PROGRESS_STATUS = exports.INITIAL_STATUS = exports.getGeoLocationData = exports.GeoLocationService = void 0;

var _googleGeolocationApi = _interopRequireDefault(require("../services/google-geolocation-api"));

var _sessionStorageService = _interopRequireDefault(require("./session-storage-service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// create a uniqe symble
var singleton = Symbol();
/**
 *
 * This class is service to user data (country etc.)
 *
 * @example
 * import {getGeoLocationData} from './services/geo-location-service'
 * getGeoLocationData().then((data) => {
 *  // do something...
 * })
 *
 */

var GeoLocationService =
/*#__PURE__*/
function () {
  _createClass(GeoLocationService, null, [{
    key: "instance",

    /** process status */

    /** const keys */

    /**
     * @default GEO_LOCATION_DATA
     */

    /**
     * @default GEO_LOCTION_FINISHED
     */
    // return a singleton instance
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GeoLocationService();
      }

      return this[singleton];
    }
  }]);

  function GeoLocationService() {
    _classCallCheck(this, GeoLocationService);

    this.sessionStorageService = _sessionStorageService["default"];
    this.googleGeolocationAPI = _googleGeolocationApi["default"];
    this.baseURL = '/wp-json/geoLocationData/v1/geo';
    this.state = {
      status: GeoLocationService.INITIAL
    };
    this.init();
  }

  _createClass(GeoLocationService, [{
    key: "setState",
    value: function setState(newState) {
      var state = this.state;
      this.state = _objectSpread({}, state, {}, newState);

      if (this.state.status == GeoLocationService.ERROR) {
        console.error('GeoLocationService: An error occurred while trying to get user country', this.state.error);
        this.fireEvent(this.state);
      } else if (this.state.status == GeoLocationService.FINISH) {
        var _this$state = this.state,
            country = _this$state.country,
            countryCode = _this$state.countryCode,
            _state = _this$state.state,
            stateCode = _this$state.stateCode,
            city = _this$state.city,
            postalcode = _this$state.postalcode;
        this.sessionStorageService.setItem(GeoLocationService.CACHE_KEY, {
          country: country,
          countryCode: countryCode,
          state: _state,
          stateCode: stateCode,
          city: city,
          postalcode: postalcode
        });
        this.onFinish();
      }
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
    /**
     *
     * @description register the user data loaded
     * this event will fire after all the process finished
     *
     * @example import {getGeoLocationData} from './services/geo-location-service';
     *  getGeoLocationData.then((data) => console.log('user data', data));
     *  or:
     *  $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, (data) => console.log('user data', data));
     * @return {Promise<object>}
     * return Promise object
     */

  }, {
    key: "fireEvent",
    value: function fireEvent(data) {
      $(document).trigger(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, data);
    }
  }, {
    key: "onFinish",
    value: function onFinish() {
      this.fireEvent(this.state);
    }
    /**
     *
     * get the user data from incapsula service
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserData",
    value: function getUserData() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // console.log(`GET ${this.baseURL}`);
        $.get(_this.baseURL).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            }
          }

          return reject('No data recived');
        }, function (err) {
          reject(err);
        });
      });
    }
    /**
     * getUserDataUsingLocation:
     *
     * get the user data from google geocodding service
     *
     * @param {{lat: string, lan: string}} latlng
     *  lan and lat location
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserDataUsingLocation",
    value: function getUserDataUsingLocation(latlng) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        // console.log(`POST ${this.baseURL}`, latlng);
        $.post(_this2.baseURL, latlng).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            } else {
              return reject('No data provided, no country name was return');
            }
          } else {
            return reject('No data provided, failed');
          }
        }, function (err) {
          reject('request to server failed ' + err);
        });
      });
    }
  }, {
    key: "getLatLan",
    value: function getLatLan() {
      return this.googleGeolocationAPI.getLatLan();
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      this.setState({
        status: GeoLocationService.IN_PROGRESS
      }); // if the data already in cache return from cache

      var data = this.sessionStorageService.getItem(GeoLocationService.CACHE_KEY); // if the data found in cache return this data;

      if (data) {
        this.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
        return;
      } // else, start request the user data from the server
      // tring to get the user country name from incapsula service


      this.getUserData().then(function (data) {
        /**
         * if got the data finish the process and save the data to state and fire finish event
         */
        _this3.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
      }, // else; try another way:
      function (err) {
        // get the lan and lat location from google service
        _this3.getLatLan().then(function (latlng) {
          // parse the lan lat location to country name unsing google geocoding service
          _this3.getUserDataUsingLocation(latlng).then(function (data) {
            // if got the data finish the process and save the data to state and fire finish event
            _this3.setState(_objectSpread({
              status: GeoLocationService.FINISH
            }, data));
          }, function (err) {
            // console.error('Faild to get user data with latlan', err);
            _this3.setState({
              status: GeoLocationService.ERROR,
              error: err
            });
          });
        }, function (err) {
          // console.error('Faild to get user data', err);
          _this3.setState({
            status: GeoLocationService.ERROR,
            error: err
          });
        });
      });
    }
  }], [{
    key: "getGeoLocationData",
    value: function getGeoLocationData() {
      var instance = GeoLocationService.instance;
      return new Promise(function (resolve, reject) {
        if (instance.getState().status == GeoLocationService.FINISH) {
          resolve(instance.getState());
        } else {
          var cbFn = function cbFn(_, data) {
            reject(data.error);
            $(document).off(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
          };

          reject('No country data found');
          $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
        }
      });
    }
  }]);

  return GeoLocationService;
}();

exports.GeoLocationService = GeoLocationService;

_defineProperty(GeoLocationService, "INITIAL", 'INITIAL');

_defineProperty(GeoLocationService, "IN_PROGRESS", 'IN_PROGRESS');

_defineProperty(GeoLocationService, "FINISH", 'FINISH');

_defineProperty(GeoLocationService, "ERROR", 'ERROR');

_defineProperty(GeoLocationService, "CACHE_KEY", 'GEO_LOCATION_DATA');

_defineProperty(GeoLocationService, "GEO_LOCTION_FINISHED_EVENT", 'GEO_LOCTION_FINISHED');

var getGeoLocationData = GeoLocationService.getGeoLocationData;
exports.getGeoLocationData = getGeoLocationData;
var INITIAL_STATUS = GeoLocationService.INITIAL;
exports.INITIAL_STATUS = INITIAL_STATUS;
var IN_PROGRESS_STATUS = GeoLocationService.IN_PROGRESS;
exports.IN_PROGRESS_STATUS = IN_PROGRESS_STATUS;
var FINISH_STATUS = GeoLocationService.FINISH;
exports.FINISH_STATUS = FINISH_STATUS;
var ERROR_STATUS = GeoLocationService.ERROR;
exports.ERROR_STATUS = ERROR_STATUS;
var _default = GeoLocationService.instance;
exports["default"] = _default;

},{"../services/google-geolocation-api":22,"./session-storage-service":23}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _googleApi = _interopRequireDefault(require("../config/google-api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var API_KEY = _googleApi["default"].API_KEY,
    BASE_URL = _googleApi["default"].BASE_URL; // create a uniqe symble

var singleton = Symbol();

var GoogleGeolocationAPI =
/*#__PURE__*/
function () {
  function GoogleGeolocationAPI() {
    _classCallCheck(this, GoogleGeolocationAPI);
  }

  _createClass(GoogleGeolocationAPI, [{
    key: "createRequest",
    value: function createRequest(url) {
      return new Promise(function (resolve, reject) {
        $.post(url).done(resolve).fail(reject);
      });
    } // return a promise

  }, {
    key: "getLatLan",
    value: function getLatLan() {
      var url = "".concat(BASE_URL, "?key=").concat(API_KEY);
      return this.createRequest(url).then(function (res) {
        var _res$location = res.location,
            lat = _res$location.lat,
            lng = _res$location.lng; // convert lng to lan

        return {
          lat: lat,
          lan: lng
        };
      })["catch"](function (err) {
        return console.error('Faild to request lan - lat from google api');
      });
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GoogleGeolocationAPI();
      }

      return this[singleton];
    }
  }]);

  return GoogleGeolocationAPI;
}();

var _default = GoogleGeolocationAPI.instance;
exports["default"] = _default;

},{"../config/google-api":18}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isBrowserSupportSessionStorage = function isBrowserSupportSessionStorage() {
  return 'sessionStorage' in window;
}; // create a uniqe symble


var singleton = Symbol();

var SessionStorageService =
/*#__PURE__*/
function () {
  _createClass(SessionStorageService, null, [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new SessionStorageService();
      }

      return this[singleton];
    }
  }]);

  function SessionStorageService() {
    _classCallCheck(this, SessionStorageService);

    this.isSupported = isBrowserSupportSessionStorage();

    if (this.isSupported) {
      this.sessionStorage = window.sessionStorage;
    }
  }
  /**
   * load the value from sessionStorage
   * the value will parse to object using JSON.parse
   * @param {string} key
   * @param {object} value
   * @return {object}
   * TODO: implement expired date option, should return null if date is expired
   */


  _createClass(SessionStorageService, [{
    key: "getItem",
    value: function getItem(key) {
      try {
        if (!this.isSupported) return null;
        var value = this.sessionStorage.getItem(key);

        if (value) {
          return JSON.parse(value);
        } else {
          return null;
        }
      } catch (error) {
        console.log('An error occurred in SessionStorageService:getItem', error);
      }
    }
    /**
     * save the value in sessionStorage
     * the value will parse to string using JSON.stringify
     * @param {string} key
     * @param {object} value
     * @return {object}
     * TODO: implement expired date option,
     * should save the expired date as new item
     */

  }, {
    key: "setItem",
    value: function setItem(key, value) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.log('An error occurred in SessionStorageService:setItem', error);
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.removeItem(key);
      } catch (error) {
        console.log('An error occurred in SessionStorageService:removeItem', error);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.clear();
      } catch (error) {
        console.log('An error occurred in SessionStorageService:clear', error);
      }
    }
  }, {
    key: "generateKey",
    value: function generateKey(object) {
      var _this = this;

      if (!object) {
        return '';
      } else if (Array.isArray(object)) {
        return object.map(function (i) {
          return _this.generateKey(i);
        }).join('_');
      } else if (_typeof(object) === 'object') {
        return Object.keys(object).map(function (key) {
          return key + '_' + _this.generateKey(object[key]);
        }).join('_');
      }

      return object;
    }
  }]);

  return SessionStorageService;
}();

var _default = SessionStorageService.instance;
exports["default"] = _default;

},{}],24:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function byString(o, s) {
  try {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

    s = s.replace(/^\./, ''); // strip a leading dot

    var a = s.split('.');

    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];

      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }

    return o;
  } catch (error) {
    return undefined;
  }
}

var TranslateService =
/*#__PURE__*/
function () {
  _createClass(TranslateService, null, [{
    key: "instance",
    get: function get() {
      if (!global.TranslateService) {
        global.TranslateService = new TranslateService();
      }

      return global.TranslateService;
    }
  }]);

  function TranslateService() {
    _classCallCheck(this, TranslateService);

    this.translate = this.translate.bind(this);
  }

  _createClass(TranslateService, [{
    key: "getTranlateMap",
    value: function getTranlateMap() {
      if (!this.tranlateMap) {
        this.tranlateMap = window.TranslateMap;
      }

      return this.tranlateMap;
    }
    /**
     * translate and field from Translate Option page on WP admin
     *
     * @param {string} field the field name (i.e. 'marketo_form.full_name_error_message')
     * @param {string | any} defaultValue if value is not exsist return this default value
     * @return {string} the translated text (or default value)
     *
     * @example
     *    import { translate } from 'impv/src/js/services/translate-service';
     *    translate('section.field_name', 'some_default_value_str');
     * 
     */

  }, {
    key: "translate",
    value: function translate() {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tranlateMap = this.getTranlateMap();

      if (!field || !tranlateMap) {
        return defaultValue;
      } else {
        return byString(tranlateMap, field) || defaultValue;
      }
    }
  }]);

  return TranslateService;
}();

var _default = TranslateService.instance;
exports["default"] = _default;
var translate = TranslateService.instance.translate;
exports.translate = translate;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[19]);
